
import React, {useEffect, useState, useRef, useContext, useCallback, useMemo  } from "react";
import {Navigate, useNavigate, useLocation } from 'react-router-dom'
import { Grid, Table, TableRow, TableBody, TableContainer, TableHead, TableCell, Fab, MenuItem, LinearProgress, ButtonGroup, InputAdornment, FormControlLabel, DialogContent, makeStyles, Checkbox, ListItemSecondaryAction, Collapse, Button, TextField, CardActions, DialogActions, DialogContentText, Tooltip, Card, Dialog, ListItemText, CardHeader, IconButton, ListItemAvatar, Typography, CardContent, Avatar, Snackbar, List, DialogTitle, ListItem, CircularProgress, Divider, ListItemIcon, Paper  } from '@material-ui/core';
import {HelperStepsContext, ExamsRegisteredContext, HelpActivatedContext, RegisteredRefferalsContext, medicinesSuggestedContext, repeatIntervalsContext, MedicinesShortageContext, spcContext, diseasesContext, uninsuredExeptionChosenContext, overrideContext, recomendationInfoContext, VisitIdContext, contraindicationsContext, NonincasesContext, PrescriptionRegisteredContext, RepeatsContext, DiagnosisAutocompleteContext, PrescriptionsNonParticipationCasesContext, MedicationRegisteredContext, PercentagesContext, FrequenciesContext, DosesContext, LoggedContext, DataContext, UnitContext, LimitContext, InsuranceContext, PatientInfoContext, MedicinesAutocompleteContext, ParametersContext } from '../../Context'
import { HourglassEmpty, Lock, ExposureNeg1, Edit, Info, Minimize, Maximize, Close, PanTool, History, Send, Email, Print, ArrowBack, Cancel, Description, Search, Delete, Accessibility, VisibilityOff, Visibility, CancelPresentationOutlined, CropLandscapeOutlined, ExpandLessRounded  } from '@material-ui/icons';
import Autocomplete , { createFilterOptions }from '@material-ui/lab/Autocomplete';
import { indigo, deepPurple, purple, green, blueGrey, red, grey } from '@material-ui/core/colors';
import Fuse from 'fuse.js'
import {FaHospital, FaPills, FaSyringe, FaFilePrescription, FaSleigh} from "react-icons/fa";
import { Alert, AvatarGroup } from '@material-ui/lab';
import debounce from "lodash/debounce"
import Masonry from 'react-masonry-css'

import { Provider, ErrorBoundary, useRollbar  } from '@rollbar/react'

import {PrescriptionDashboard} from'../MainPage/Fab'

import {DemoMessage, DemoDialog} from'../MainPage/MainPage'
import { useDemoStore } from '../../Stores/demoStore'

import useStore from '../../Stores/prescriptionStore';

const rollbarConfig = {
    accessToken: process.env.REACT_APP_ROLLBAR_TOKEN,
    environment: process.env.REACT_APP_ROLLBAR_ENV,
}


 

/*
Component for closing / canceling visit
Renders 2 buttons and some dialogs
*/
export const NavigationButtons = () => {

 

    //Doctor info
    const [data] = useContext(DataContext)
    //The visit Id
    const [visitId, setVisitId] = useContext(VisitIdContext)
    //The main info of the patient (name, age , insurance , ...)
    const [patientInfo, setPatientInfo] = useContext(PatientInfoContext)
    //Activates deactivates the CancelVisit Dialog
    const [openCancelVisit, setOpenCancelVisit] = useState(false)
    //Activates deactivates the CloseVisit Dialog
    const [openCloseVisit, setOpenCloseVisit] = useState(false)
    //Activates deactivates the reference snackbar error
    const [referenceError, setReferenceError] = useState(false)
    //Shows or hides the tooltip dialog
    const [openHelp, setOpenHelp] = useState(false)
    //The full information of the medications the user prescribed (arrray of objects)
    const [medicationRegistered, setMedicationRegister] = useContext(MedicationRegisteredContext)
    const [steps, setSteps] = useContext(HelperStepsContext)
    const [registeredRefferals, setRegisteredRefferals] = useContext(RegisteredRefferalsContext)
    const [examsRegistered, setExamsRegister] = useContext(ExamsRegisteredContext)

    const setNewVisit = useStore(state => state.setNewVisit);
    const prescriptions = useStore(state => state.prescriptions);
    const sentPrescritions = prescriptions.filter(x=>x.sent)
    const sentRefferals = registeredRefferals.filter(x=>x.sent)
    

    

    const newVisit = {
        id: "V10020",
        patientInfo: {
          lastName: "Παύλου",
          firstName: "Παύλος",
          amka: "12345678901",
          socialInsuranceShortName: "ΕΟΠΥΥ"
        },
        startDate: "2025-02-18 09:00",
        status: { id: 2, status: "ΟΛΟΚΛΗΡΩΜΕΝΗ" },
        inQuota: true,
        Prescriptions: sentPrescritions.map(y=>{
            return{
                Prescription_Barcode: y.id,
                Prescription_Status: "ΣΥΝΤΑΓΟΓΡΑΦΗΜΕΝΗ",
                Treatment: y.medicines.map(xx=>{
                    return{
                        Medication: xx.MedicationInfo.commercialName + " " +  xx.MedicationInfo.content  + " " +  xx.MedicationInfo.doseUnit,
                        Quantity_Value: xx.Quantity.id,
                        Dose_Value:  xx.Dose.id,
                        Dose_Unit: "Δισκίο",
                        Frequency: xx.Frequency.name,
                        Duration_Value: xx.Days.id,
                        Diagnosis: [xx.Diagnosis.title]
                    }
                })
              }
        }),
        Referrals: sentRefferals.map(y=>{
            return{
                Referral_Barcode: y.id,
                Referral_Status: "ΣΥΝΤΑΓΟΓΡΑΦΗΜΕΝΟ",
                Test: y.exams.map(xx=>{
                    return{
                        Procedure: xx.examination.examInfo.description,
                        Diagnosis: xx.diagnosis.title
                    }
                })
              }
        }),
        timestamp: Date.now(),
        ConsentPrescription: true,
        ConsentRefferal: true
    }


    //Load the help tooltip after 1 second
    useEffect(()=>{
        const sent = medicationRegistered.filter(x=>x.sent)

        if(window.location.pathname==="/PrescriptionPage" && sent.length!==0 && steps.status && (!openCloseVisit || !openCancelVisit) ){
       
            setTimeout(() =>setOpenHelp(true) , 4000)
        }
        else{
            setOpenHelp(false)
        }
        
    },[medicationRegistered]) 

    //Styles for the CreatePrescription component
    const useStyles = makeStyles((theme) => ({
        tooltip: {
            backgroundColor: 'rgba(0, 0, 0, 0.3)', // Adjust the opacity here (last digit)
        }
    }))
    const classes = useStyles();


    /*
    Dialog component to cancel the visit
    Renders a dilog and a snackbar
    */
    const CancelVisit = () => {


        const resetAll = useStore(state => state.resetAll);
  
        //Close the error snackbar
        const cancelVisit = () => {
            resetAll();
            setNewVisit({...newVisit,status: { id: 1, status: "ΑΚΥΡΩΜΕΝΗ" }, Prescriptions:[], Referrals:[]  })
            setRegisteredRefferals([])
            setExamsRegister([])
            navigate("/MainPage")
        }
        //Close the error snackbar
        const handleCloseDialog = () => {

            setOpenCancelVisit(false)
        }


        
 


        return(
            <>
                <Dialog
                open={openCancelVisit}
                onClose={handleCloseDialog}
                maxWidth='sm'
                >
                  

                    <DialogTitle>
                        Ακύρωση επίσκεψης
                    </DialogTitle>

                    <DialogContent>
                        <Typography  variant='subtitle2' color='textSecondary'>
                            Προκειται να ακυρώσετε την τρέχουσα επίσκεψη καθώς και όλες τις συνταγές και παραπεμπτικά που έχετε δημιουργήσει.<br></br>
                            <br></br>
                            Κωδικός επίσκεψης: {visitId}<br></br>
                            Ασθενής: {patientInfo.generalInfo.data.lastName} {patientInfo.generalInfo.data.firstName}<br></br>
                        </Typography>
                    </DialogContent>

                    <DialogActions>
                        <Button variant="outlined" color="secondary" onClick={handleCloseDialog}>
                            ΕΠΙΣΤΡΟΦΗ
                        </Button>
                        <Button  variant="outlined" color="primary" onClick={() => cancelVisit()} >
                            ΑΚΥΡΩΣΗ
                        </Button>
                    </DialogActions>

                </Dialog>


            </>
        )
    }
    /*
    Dialog component to close the visit
    Renders a dilog and a snackbar
    */
    const CloseVisit = () => {

        const resetAll = useStore(state => state.resetAll);
    
        //Close the visit
         function closeVisitFunc() {

            resetAll();
            setNewVisit(newVisit)
            setRegisteredRefferals([])
            setExamsRegister([])
            navigate("/MainPage")
            
        }
  
        //Close the close visit Dialog 
        function closeDialog (){

            setOpenCloseVisit(false)
        }

       


        return(

                <Dialog
                disableBackdropClick 
                disableEscapeKeyDown 
                open={openCloseVisit}
                onClose={closeDialog}
                maxWidth='sm'
                >
                  
                    <DialogTitle >
                        Κλείσιμο επίσκεψης
                    </DialogTitle>

                    <DialogContent>

           
                    
                        <DialogContentText >
                            <Typography variant='subtitle2' colr='textSecondary'>
                                Προκειται να κλείσετε την τρέχουσα επίσκεψη.
                                <br></br>
                                <br></br>
                                Κωδικός επίσκεψης: {visitId}<br></br>
                                Ασθενής: {patientInfo.generalInfo.data.lastName} {patientInfo.generalInfo.data.firstName}
                            </Typography>
                       
                 
                

                            

                        </DialogContentText>
                        
                
                    </DialogContent>
                        

                    <DialogActions>
                        <Button variant="outlined" color="secondary" onClick={closeDialog}>
                        ΕΠΙΣΤΡΟΦΗ
                        </Button>
                        <Button  variant="outlined" color="primary" onClick={() => closeVisitFunc()} autoFocus >
                        ΚΛΕΙΣΙΜΟ
                        </Button>
                    </DialogActions>

                </Dialog>

        )
    }

    const navigate = useNavigate()

    //Opens the close dialog
    const handleCloseVisit = ()=>{

        if(patientInfo.reference){

            setReferenceError(true)
        
        }
        else{
            setReferenceError(false)

            setOpenCloseVisit(true)
        }

        
    }
    //Opens the cancel dialog
    const handleCancelVisit = ()=>{
        setOpenCancelVisit(true)
    }
    //Closes the snackbar
    const handleCloseSnackbar = ()=>{
        setReferenceError(false)
    }


    return(
        
        
  
        <Provider config={rollbarConfig}>
        
        
            <Grid
            id="close"
            spacing={2}
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="flex-end"
            >

        
        
            <Grid item >
            <Button variant="contained" color="secondary" className="cancel" onClick={handleCancelVisit}>ΑΚΥΡΩΣΗ ΕΠΙΣΚΕΨΗΣ</Button>
            </Grid>
            <Grid item >
            <Button variant="contained" color="primary"  onClick={handleCloseVisit}>ΚΛΕΙΣΙΜΟ ΕΠΙΣΚΕΨΗΣ</Button> 
            </Grid>
            
            
            </Grid>

            <Snackbar open={referenceError} onClose={handleCloseSnackbar}>
                <Alert 
                onClose={handleCloseSnackbar} 
                variant='filled'
                severity="error"
                >
                Πρίν κλείσετε την επίσκεψη, θα πρέπει να ολοκληρώσετε την ενεργή παραπομπή του ασθενή.
                </Alert>
            </Snackbar>

            <CancelVisit/>

            <CloseVisit/>

        </Provider>
       
        

    )
 
}



/*
Component that renders the main patient info when the user is in the Prescription page
Renders some text
*/
export const PatientInfo = () => {

    //The main info of the patient (name, age , insurance , ...)
    const [patientInfo, setPatientInfo] = useContext(PatientInfoContext)
    //The selected insurance for the visit (a patient might have more than one insurances)
    const [selectedInsurance,setSelectedInsurance] = useContext(InsuranceContext)
    const [steps, setSteps] = useContext(HelperStepsContext)
    //HelpActivatedContext data the tooltips show condition
    const [helpActivatedTooltips, setHelpActivatedTooltips] = useContext(HelpActivatedContext)

    const setDemoMessage = useDemoStore(state => state.setDemoMessage)
   
   

  
  



    const useStyles = makeStyles((theme) => ({

        default: {
            height:'3rem',
            color: 'inherit'
        },
        indigo: {
          backgroundColor: indigo[300],
          color: 'inherit'
        },
        deepPurple: {
          backgroundColor: deepPurple[200],
          color: 'inherit'
        },
        purple: {
          backgroundColor: purple[200],
          color: 'inherit'
        }
    }))

    const classes = useStyles();
    const navigate = useNavigate();

    const handleGoToReferrals = ()=>{
        if(window.location.pathname!=="/ReferralPage"){
            navigate("/ReferralPage")
        }
    }   
    const handleGoToReferences = ()=>{
        setDemoMessage({
            status:true,
            severity:"info",
            description: "το κουμπί ανοίγει την σελίδα καταχώρησης παραπομπής."
        })
    }
    const handleGoToPrescription = ()=>{
        if(window.location.pathname!=="/PrescriptionPage"){
            navigate("/PrescriptionPage")
        }
    }
    const handleGoToPatientPage = ()=>{
        setDemoMessage({
            status:true,
            severity:"info",
            description: "το κουμπί ανοίγει το ιστορικό του ασθενούς που προβλήθηκε προηγουμένως κατά το άνοιγμα της επίσκεψης"
        })
    }



    return(
       
        <Grid
        container
        spacing={1}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        >       

            <Grid style={{minWidth:"15rem"}} item xs>
               
                    <Grid
                    container
                    spacing={1}
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    >   
                        <Tooltip title= {!helpActivatedTooltips ?             
                        <Typography variant='subtitle2' color="inherit">Για να δείτε τον ιατρικό φάκελο του ασθενή, πατήστε στο εικονίδιο του ανθρώπου.</Typography>
                        :''} >
                            <Grid item >
                            
                                <IconButton variant='outlined' onClick={handleGoToPatientPage}>
                                    <Avatar >
                                       
                                    </Avatar> 
                                </IconButton>
                            
                            </Grid>
                        </Tooltip>
                        <Grid item >
                            <Grid
                            container
                            direction="column"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                            > 
                                <Grid item >
                                    <Typography color="inherit" variant="subtitle2">
                                        <strong>{patientInfo.generalInfo.data.lastName}  {patientInfo.generalInfo.data.firstName}</strong>
                                    </Typography>
                                </Grid>
                                <Grid item >
                                    <Typography color="inherit" variant="subtitle2">
                                        {patientInfo.generalInfo.Age} ετών {selectedInsurance.socialInsurance.shortName}
                                    </Typography>
                                </Grid> 
                            </Grid>
                        </Grid>
                    </Grid>
          
            </Grid>

            
        
            <Grid item   >

                <ButtonGroup color="inherit" variant="outlined" size='small'>

                    <Tooltip title= {!helpActivatedTooltips ?
                    <React.Fragment>
                        <Typography  variant='h6' color="inherit">Καταχώρηση συνταγής φαρμάκων</Typography>
                        <Typography variant='subtitle2' color="inherit">Για να καταχωρήσετε ένα φάρμακο σε έναν ασθενή, κάντε κλικ στο ΦΑΡΜΑΚΟ. Αυτό θα σας μεταφέρει στη σελίδα συνταγογραφήσεων φαρμάκων.</Typography>
                    </React.Fragment>
                    :''} >
                        <Button  style={window.location.pathname==="/PrescriptionPage" ? {backgroundColor: "#7986cb",color: 'inherit'} : {height:'3rem',color: 'inherit'}}  onClick={handleGoToPrescription} >
                            <Typography variant='subtitle2' noWrap>
                                ΦΑΡΜΑΚΑ
                            </Typography>          
                        </Button>
                    </Tooltip>

                    <Tooltip title= {!helpActivatedTooltips ?
                    <React.Fragment>
                        <Typography  variant='h6' color="inherit">Καταχώρηση παραπεμπτικού εξετάσεων</Typography>
                        <Typography variant='subtitle2' color="inherit">Κάνοντας κλικ στο "Εξετάσεις", θα μεταφερθείτε στη σελίδα παραπεμπτικών εξετάσεων. Στη σελίδα αυτή, μπορείτε να καταχωρήσετε εξετάσεις στον ασθενή, είτε μέσω της "Υποβοήθησης διάγνωσης" είτε μέσω της αναζήτησης εξετάσεων.</Typography>
                    </React.Fragment>
                    :''} >
                        <Button className="selectExamsPage" style={window.location.pathname==="/ReferralPage" ? {backgroundColor: "#b39ddb",color: 'inherit'} : {height:'3rem',color: 'inherit'}}  onClick={handleGoToReferrals} >
                            <Typography variant='subtitle2' noWrap>
                                ΕΞΕΤΑΣΕΙΣ
                            </Typography> 
                        </Button>
                    </Tooltip>

                    <Tooltip title= {!helpActivatedTooltips ?
                    <React.Fragment>
                        <Typography  variant='h6' color="inherit">Καταχώρηση παραπομπής σε άλλο ιατρό</Typography>
                        <Typography variant='subtitle2' color="inherit">Για να παραπέμψετε έναν ασθενή, κάντε κλικ στο "Παραπομπή". Στη σελίδα αυτή, μπορείτε να επιλέξετε τον τύπο της παραπομπής, τον γιατρό ή το νοσοκομείο που θέλετε να παραπέμψετε τον ασθενή και να εισαγάγετε τις απαραίτητες πληροφορίες.</Typography>
                    </React.Fragment>
                    :''} >
                        <Button className="referencesSelect" style={window.location.pathname==="/ReferencePage" ? {backgroundColor: "#ce93d8",color: 'inherit'} : {height:'3rem',color: 'inherit'}}  onClick={handleGoToReferences} >
                            <Typography variant='subtitle2' noWrap>
                                ΠΑΡΑΠΟΜΠΕΣ
                            </Typography> 
                        </Button>
                    </Tooltip>
    
                </ButtonGroup>
            
            </Grid>

        </Grid>
         
    )
}   

//The main component used to create and present the prescriptions
export const PrescriptionPage = () => {

    const setDemoMessage = useDemoStore(state => state.setDemoMessage)
    const setDemoDialog = useDemoStore(state => state.setDemoDialog)
    const newVisit = useStore(state => state.newVisit);

    useEffect( ()=> {
        if(!newVisit){
            setDemoDialog({ 
                status:true,
                description:<> 
                <Typography variant="body1" gutterBottom>
                    <strong>Καλώς ήρθατε στη σελίδα καταχώρησης συνταγών και φαρμάκων!</strong>
                </Typography>
                <br></br>
              <Typography variant="subtitle2" >
                Εδώ μπορείτε να καταχωρήσετε εύκολα τα φάρμακα και τις συνταγές σας.
              </Typography>
              
              <Typography variant="subtitle2" paragraph >
                Στο πάνω δεξί μέρος της σελίδας, μπορείτε να εναλλάξετε μεταξύ καταχώρησης φαρμάκων και εξετάσεων. 
                Για να επιστρέψετε στο ιστορικό του ασθενούς, κάντε κλικ στο εικονίδιο του ανθρωπάκου που βρίσκεται στο πάνω αριστερό μέρος της σελίδας.
              </Typography>
              
       
              
              <Typography variant="subtitle2" >
                <strong>Η συνταγογράφηση είναι αυτοματοποιημένη</strong> και μπορεί να γίνει με δύο τρόπους:
              </Typography>
              
              <Typography variant="subtitle2" >
                1. μέσω της αναζήτησης φαρμάκου
              </Typography>
              <Typography variant="subtitle2" paragraph>
                2. μέσω της υποβοηθούμενης συνταγογράφησης
              </Typography>
   
              
              <Typography variant="subtitle2" paragraph>
                Και στις δύο περιπτώσεις, το μόνο που χρειάζεται να κάνετε είναι να επιλέξετε τα φάρμακα. Η εφαρμογή θα συμπληρώσει αυτόματα το δοσολογικό σχήμα, τη διάγνωση και τα θεραπευτικά πρωτόκολλα, βάσει του επιλεγμένου φαρμάκου και των χαρακτηριστικών του ασθενούς.
              </Typography>
              
              <Typography variant="subtitle2">
                <strong>Σημαντικό:</strong> Αυτή είναι μια demo έκδοση, και οι συνταγές που θα εκδοθούν ΔΕΝ ΕΙΝΑΙ ΠΡΑΓΜΑΤΙΚΕΣ.
              </Typography>
              </>
            
            })
        }
    },[]) 



    


    const PrescriptionPageAuxiliary  = () => {
        
      
        //Checks if the user is logged in
        const [logged, setLogged] = useContext(LoggedContext)
        //The main info of the patient (name, age , insurance , ...)
  

        //HelpActivatedContext data the tooltips show condition
        const [helpActivatedTooltips, setHelpActivatedTooltips] = useContext(HelpActivatedContext)
        

   

        const dummyMedicines = [
            // Regular medicines (5) - without suggested attribute
            {
              id: "1",
              barcode: "28030033",
              commercialName: "PARACETAMOX",
              content: "500MG",
              packageForm: "TAB",
              inCirculation: true,
              ePresEnabled: true,
              nonPrescriptable: false,
              withdrawn: false,
              isConsumable: false,
              negativeList: false,
              activeSubstances: {
                activeSubstance: {
                  mainActiveSubstance: true,
                  activeSubstance: {
                    id: 1,
                    description: "Paracetamol"
                  }
                }
              },
              doseUnit: "TAB",
              retailPrice: "2.5",
              atcCode: "N02BE01",
              participationPercentage: 25,
              onlyByProtocol: false
            },
            {
              id: "2",
              barcode: "28030034",
              commercialName: "AMOXICLAV",
              content: "875+125MG",
              packageForm: "TAB",
              inCirculation: true,
              ePresEnabled: true,
              nonPrescriptable: false,
              withdrawn: false,
              isConsumable: false,
              negativeList: false,
              activeSubstances: {
                activeSubstance: {
                  mainActiveSubstance: true,
                  activeSubstance: {
                    id: 2,
                    description: "Amoxicillin+Clavulanic acid"
                  }
                }
              },
              doseUnit: "TAB",
              retailPrice: "5.8",
              atcCode: "J01CR02",
              participationPercentage: 25,
              onlyByProtocol: false
            },
            {
              id: "3",
              barcode: "28030035",
              commercialName: "DICLOFENAC-X",
              content: "50MG",
              packageForm: "TAB",
              inCirculation: true,
              ePresEnabled: true,
              nonPrescriptable: false,
              withdrawn: false,
              isConsumable: false,
              negativeList: false,
              activeSubstances: {
                activeSubstance: {
                  mainActiveSubstance: true,
                  activeSubstance: {
                    id: 3,
                    description: "Diclofenac"
                  }
                }
              },
              doseUnit: "TAB",
              retailPrice: "4.2",
              atcCode: "M01AB05",
              participationPercentage: 25,
              onlyByProtocol: false
            },
            {
              id: "4",
              barcode: "28030036",
              commercialName: "METOCLOMAX",
              content: "10MG",
              packageForm: "TAB",
              inCirculation: true,
              ePresEnabled: true,
              nonPrescriptable: false,
              withdrawn: false,
              isConsumable: false,
              negativeList: false,
              activeSubstances: {
                activeSubstance: {
                  mainActiveSubstance: true,
                  activeSubstance: {
                    id: 4,
                    description: "Metoclopramide"
                  }
                }
              },
              doseUnit: "TAB",
              retailPrice: "3.1",
              atcCode: "A03FA01",
              participationPercentage: 25,
              onlyByProtocol: false
            },
            {
              id: "5",
              barcode: "28030037",
              commercialName: "DESLORAT",
              content: "5MG",
              packageForm: "TAB",
              inCirculation: true,
              ePresEnabled: true,
              nonPrescriptable: false,
              withdrawn: false,
              isConsumable: false,
              negativeList: false,
              activeSubstances: {
                activeSubstance: {
                  mainActiveSubstance: true,
                  activeSubstance: {
                    id: 5,
                    description: "Desloratadine"
                  }
                }
              },
              doseUnit: "TAB",
              retailPrice: "6.2",
              atcCode: "R06AX27",
              participationPercentage: 25,
              onlyByProtocol: false
            },
          
            // Chronic medicines (3)
            {
              id: "6",
              barcode: "28030038",
              Group: "Χρόνια φάρμακα . . .",
              suggested: {
                diagnosis: [{
                  Group: 1,
                  id: 6,
                  code: "I10",
                  title: "Υπέρταση",
                  description: "Ιδιοπαθής υπέρταση",
                  onlyByProtocol: true
                }]
              },
              commercialName: "BISOPROZIN",
              content: "5MG",
              packageForm: "TAB",
              inCirculation: true,
              ePresEnabled: true,
              nonPrescriptable: false,
              withdrawn: false,
              isConsumable: false,
              negativeList: false,
              activeSubstances: {
                activeSubstance: {
                  mainActiveSubstance: true,
                  activeSubstance: {
                    id: 6,
                    description: "Bisoprolol"
                  }
                }
              },
              doseUnit: "TAB",
              retailPrice: "8.5",
              atcCode: "C07AB07",
              participationPercentage: 10,
              onlyByProtocol: false,
              repeat: 3
            },
            {
              id: "7",
              barcode: "28030039",
              Group: "Χρόνια φάρμακα . . .",
              suggested: {
                diagnosis: [{
                  Group: 1,
                  id: 7,
                  code: "E11",
                  title: "Διαβήτης",
                  description: "Σακχαρώδης διαβήτης τύπου 2",
                  onlyByProtocol: true
                }]
              },
              commercialName: "METFORAL",
              content: "850MG",
              packageForm: "TAB",
              inCirculation: true,
              ePresEnabled: true,
              quantity:"2",
              dose:2,
              nonPrescriptable: false,
              withdrawn: false,
              isConsumable: false,
              negativeList: false,
              activeSubstances: {
                activeSubstance: {
                  mainActiveSubstance: true,
                  activeSubstance: {
                    id: 7,
                    description: "Metformin"
                  }
                }
              },
              doseUnit: "TAB",
              retailPrice: "4.8",
              atcCode: "A10BA02",
              participationPercentage: 10,
              onlyByProtocol: false,
              repeat: 3
            },
            {
              id: "8",
              barcode: "28030040",
              dose:1.5,
              quantity:"2",
              Group: "Χρόνια φάρμακα . . .",
              suggested: {
                diagnosis: [{
                  Group: 1,
                  id: 8,
                  code: "E78",
                  title: "Υπερλιπιδαιμία",
                  description: "Διαταραχές μεταβολισμού λιποπρωτεϊνών",
                  onlyByProtocol: true
                }]
              },
              commercialName: "ATOREX",
              content: "20MG",
              packageForm: "TAB",
              inCirculation: true,
              ePresEnabled: true,
              nonPrescriptable: false,
              withdrawn: false,
              isConsumable: false,
              negativeList: false,
              activeSubstances: {
                activeSubstance: {
                  mainActiveSubstance: true,
                  activeSubstance: {
                    id: 8,
                    description: "Atorvastatin"
                  }
                }
              },
              doseUnit: "TAB",
              retailPrice: "12.4",
              atcCode: "C10AA05",
              participationPercentage: 10,
              onlyByProtocol: true,
              repeat: 3
            },
          
            // Suggested medicines (2)
            {
              id: "9",
              barcode: "28030041",
              Group: "Προτεινόμενα φάρμακα . . .",
              suggested: {
                diagnosis: [{
                  Group: 1,
                  id: 9,
                  code: "M81",
                  title: "Οστεοπόρωση",
                  description: "Οστεοπόρωση χωρίς παθολογικό κάταγμα",
                  onlyByProtocol: true
                }]
              },
              commercialName: "ALENDRONAT",
              content: "70MG",
              packageForm: "TAB",
              inCirculation: true,
              ePresEnabled: true,
              nonPrescriptable: false,
              withdrawn: false,
              isConsumable: false,
              negativeList: false,
              activeSubstances: {
                activeSubstance: {
                  mainActiveSubstance: true,
                  activeSubstance: {
                    id: 9,
                    description: "Alendronate"
                  }
                }
              },
              doseUnit: "TAB",
              retailPrice: "15.6",
              atcCode: "M05BA04",
              participationPercentage: 10,
              onlyByProtocol: true
            },
            {
              id: "10",
              barcode: "28030042",
              Group: "Προτεινόμενα φάρμακα . . .",
              suggested: {
                diagnosis: [{
                  Group: 1,
                  id: 10,
                  code: "G47",
                  title: "Αϋπνία",
                  description: "Διαταραχές ύπνου",
                  onlyByProtocol: true
                }]
              },
              commercialName: "ZOLPINOX",
              content: "10MG",
              packageForm: "TAB",
              inCirculation: true,
              ePresEnabled: true,
              nonPrescriptable: false,
              withdrawn: false,
              isConsumable: false,
              negativeList: false,
              activeSubstances: {
                activeSubstance: {
                  mainActiveSubstance: true,
                  activeSubstance: {
                    id: 10,
                    description: "Zolpidem"
                  }
                }
              },
              doseUnit: "TAB",
              retailPrice: "5.9",
              atcCode: "N05CF02",
              participationPercentage: 25,
              onlyByProtocol: true
            }
        ]
        const dummyDiagnoses = [
            {
                Group: 0,
                id: 3,
                code: "J00",
                title: "Ρινίτιδα",
                description: "Κοινό κρυολόγημα",
                onlyByProtocol: false
            },
            {
                Group: 0,
                id: 4,
                code: "K29.7",
                title: "Γαστρίτιδα",
                description: "Φλεγμονή του στομάχου",
                onlyByProtocol: false
            },
            {
                Group: 0,
                id: 5,
                code: "H10",
                title: "Επιπεφυκίτιδα",
                description: "Φλεγμονή του επιπεφυκότα",
                onlyByProtocol: true
            },
            {
                Group: 0,
                id: 6,
                code: "L23",
                title: "Δερματίτιδα",
                description: "Αλλεργική δερματική αντίδραση",
                onlyByProtocol: false
            },
            {
                Group: 0,
                id: 1,
                code: "R51",
                title: "Πονοκέφαλος",
                description: "Κεφαλαλγία",
                onlyByProtocol: false
            },
            {
                id: 7,
                code: "J45",
                title: "Άσθμα",
                description: "Χρόνια φλεγμονή των αεραγωγών",
                onlyByProtocol: true
            },
            {
                id: 8,
                code: "N30",
                title: "Κυστίτιδα",
                description: "Ουρολοίμωξη κύστης",
                onlyByProtocol: false
            },
            {
                id: 9,
                code: "E11",
                title: "Σακχαρώδης Διαβήτης",
                description: "Διαβήτης τύπου 2",
                onlyByProtocol: true
            },
            {
                id: 10,
                code: "I10",
                title: "Υπέρταση",
                description: "Υψηλή αρτηριακή πίεση",
                onlyByProtocol: true
            },
            {
                id: 11,
                code: "M25.5",
                title: "Αρθραλγία",
                description: "Πόνος στις αρθρώσεις",
                onlyByProtocol: false
            },
            {
                id: 12,
                code: "R11",
                title: "Ναυτία και έμετος",
                description: "Γαστρεντερικές διαταραχές",
                onlyByProtocol: false
            },
            // Adding missing diagnoses
            {
                id: 13,
                code: "E78",
                title: "Υπερλιπιδαιμία",
                description: "Διαταραχές μεταβολισμού λιποπρωτεϊνών",
                onlyByProtocol: true
            },
            {
                id: 14,
                code: "M81",
                title: "Οστεοπόρωση",
                description: "Οστεοπόρωση χωρίς παθολογικό κάταγμα",
                onlyByProtocol: true
            },
            {
                id: 15,
                code: "G47",
                title: "Αϋπνία",
                description: "Διαταραχές ύπνου",
                onlyByProtocol: true
            }
        ]
        const dummyChronicMedicines = [
            {
              // UI display fields
              barcode: "28030038",
              Medication: "BISOPROZIN 5MG TAB",
              diagnosisWithCode: [{
                code: "I10",
                name: "Υπέρταση - Ιδιοπαθής υπέρταση"
              }],
              selected: false,
              recomendationCheck: "0",
              patientNoPayment: "0",
          
              // Fields matching createNewPrescription structure
              MedicationInfo: {
                barcode: "28030038",
                commercialName: "BISOPROZIN",
                content: "5MG",
                isDeliverable: true,
                drug: true,
                doseUnit: "TAB"
              },
              Diagnosis: {
                title: "Υπέρταση",
                code: "I10"
              },
              Quantity: {
                id: "1",
                name: "1 συσκευασία"
              },
              Dose: {
                id: 1,
                name: "1 δισκίο"
              },
              Frequency: {
                id: 1,
                name: "1 φορά την ημέρα"
              },
              Days: {
                id: 30,
                name: "30 ημέρες"
              },
              Repeat: {
                id: 3,
                name: "3ΜΗΝΗ"
              },
              Copayment: {
                id: 3,
                name: "25",
                description: "25%"
              },
              exitIfet: {
                status: false,
                ifetForm: ""
              },
              ChronicDisease: true,
              month: false,
              twoMonth: false,
              Monodose: false,
              protocol: {
                protocolMandatory: false
              },
              comments: {
                medication: "",
                prescription: ""
              }
            },
            {
              // UI display fields
              barcode: "28030039",
              Medication: "METFORAL 850MG TAB",
              diagnosisWithCode: [{
                code: "E11",
                name: "Σακχαρώδης διαβήτης τύπου 2"
              }],
              selected: false,
              recomendationCheck: "0",
              patientNoPayment: "0",
          
              // Fields matching createNewPrescription structure
              MedicationInfo: {
                barcode: "28030039",
                commercialName: "METFORAL",
                content: "850MG",
                isDeliverable: true,
                drug: true,
                doseUnit: "TAB"
              },
              Diagnosis: {
                title: "Σακχαρώδης Διαβήτης",
                code: "E11"
              },
              Quantity: {
                id: "2",
                name: "2 συσκευασίες"
              },
              Dose: {
                id: 2,
                name: "2 δισκίο"
              },
              Frequency: {
                id: 1,
                name: "1 φορές την ημέρα"
              },
              Days: {
                id: 30,
                name: "30 ημέρες"
              },
              Repeat: {
                id: 3,
                name: "3ΜΗΝΗ"
              },
              Copayment: {
                id: 3,
                name: "25",
                description: "25%"
              },
              exitIfet: {
                status: false,
                ifetForm: ""
              },
              ChronicDisease: true,
              month: false,
              twoMonth: false,
              Monodose: false,
              protocol: {
                protocolMandatory: false
              },
              comments: {
                medication: "",
                prescription: ""
              }
            },
            {
              // UI display fields
              barcode: "28030040",
              Medication: "ATOREX 20MG TAB",
              diagnosisWithCode: [{
                code: "E78",
                name: "Υπερλιπιδαιμία - Διαταραχές μεταβολισμού λιποπρωτεϊνών"
              }],
              selected: false,
              recomendationCheck: "0",
              patientNoPayment: "0",
          
              // Fields matching createNewPrescription structure
              MedicationInfo: {
                barcode: "28030040",
                commercialName: "ATOREX",
                content: "20MG",
                isDeliverable: true,
                drug: true,
                doseUnit: "TAB"
              },
              Diagnosis: {
                title: "Υπερλιπιδαιμία",
                code: "E78"
              },
              Quantity: {
                id: "2",
                name: "2 συσκευασία"
              },
              Dose: {
                id: 1.5,
                name: "1.5 δισκίο"
              },
              Frequency: {
                id: 1,
                name: "1 φορά την ημέρα"
              },
              Days: {
                id: 30,
                name: "30 ημέρες"
              },
              Repeat: {
                id: 3,
                name: "3ΜΗΝΗ"
              },
              Copayment: {
                id: 3,
                name: "25",
                description: "25%"
              },
              exitIfet: {
                status: false,
                ifetForm: ""
              },
              ChronicDisease: true,
              month: false,
              twoMonth: false,
              Monodose: false,
              protocol: {
                protocolMandatory: true
              },
              comments: {
                medication: "",
                prescription: ""
              }
            }
        ];
          
   
     



     
        function convertEnglishToGreek(englishString) {
            const greekToEnglishMap = {
                q: ';', w: 's', j: 'ξ',
                a: 'α', b: 'β', g: 'γ', d: 'δ', e: 'ε', z: 'ζ', i: 'ι', h: 'η', u: 'θ', k: 'κ',
                l: 'λ', m: 'μ', n: 'ν', o: 'ο', p: 'π', r: 'ρ', s: 'σ', t: 'τ', y: 'υ',
                f: 'φ', x: 'χ', c: 'ψ', v: 'ω'
            }
          
            const greekString = englishString.toLowerCase().replace(/./g, function(match) {
              return greekToEnglishMap[match] || match;
            })
          
            return greekString
        }
    
    
        

       

        
        //CSS
        const useStyles = makeStyles({
            root: {
                margin:"1rem",
            }
        
        })
        const classes = useStyles()


        //Component used to create the prescription
        const CreatePrescription = () => {



        
    

                
                
            //Styles for the CreatePrescription component
            const useStyles = makeStyles((theme) => ({

                header: {
                    color: theme.palette.getContrastText(indigo[200]),
                    backgroundColor: indigo[200],
                },
                root: {     
                    backgroundColor : "#FFFFFF",
                },
                marginRight:{
                    marginRight:'1rem',
                    marginTop: '1rem'
                },
                paper:{
                    marginTop:'1rem'
                },
                minimum:{
                    minWidth:'100%'
                },
                protocolSuccess:{
                    marginRight:'1rem',
                    marginTop: '1rem',
                    color: green[600]
                },
                protocolFail:{
                    marginRight:'1rem',
                    marginTop: '1rem',
                    color: red[600]
                },
                protocolNeutral:{
                    marginRight:'1rem',
                    marginTop: '1rem',
                    color: indigo[500]
                }
                

            }))
            const classes = useStyles();

            /*
            Component that renders the recomendation
            Renders a button
            */
            const RecomendationMain = () => {



                return(
            
                    <Tooltip
                    title= {!helpActivatedTooltips ?
                    <React.Fragment>
                        <Typography variant='subtitle2' color="inherit">Εάν απαιτείται γνωμάτευση για την καταχώρηση φαρμάκων, επιλέξτε τη γνωμάτευση και συμπληρώστε τα πεδία ΑΜΚΑ ιατρού και ημερομηνία γνωμάτευσης.</Typography>
                    </React.Fragment>
                    :''} 
                    >
                    <Button 
                    color="primary"
                    className="prescriptionInfo"
                    style={{marginRight:'1rem', marginTop: '1rem', color:'#3f51b5'}} 
                    variant ='outlined' 
                    onClick={()=>   setDemoMessage({
                        status:true,
                        severity:"info",
                        description: "το κουμπί καταχωρεί την ηλ. γνωμάτευση"
                    })} >
                        ΓΝΩΜΑΤΕΥΣΗ           
                    </Button>
                    </Tooltip>
                        
                    
                )
            }    

            //The component that actualy creates the prescription (the form the doctor has to fill)
            const PrescrptionForm = () => {


        
                const selectedDiagnosis = useStore(state => state.selectedDiagnosis);
                const setSelectedDiagnosis = useStore(state => state.setSelectedDiagnosis);
                const selectedMedication = useStore(state => state.selectedMedication);
                const setSelectedMedication = useStore(state => state.setSelectedMedication);
                const resetMedicineData = useStore(state => state.resetMedicineData);

        

                useEffect( ()=> {
                    if(selectedMedication && selectedMedication.suggested) {
                        setSelectedDiagnosis(selectedMedication.suggested.diagnosis[0])
                    }
                },[selectedMedication]) 

        
        
                const Medication = () => {

        
                    
                

                    const medicinesSuggested = dummyMedicines.filter(x=>x.Group)
                    //The input of the user when searches for an exam
                    const [input, setInput] = useState(selectedMedication ? selectedMedication.commercialName : '')
                    //Control the selection status (open / close) from search 
                    const [openSearchResults, setOpenSearchResults] = useState(false)
                    //The results of the fuzzy search sorted by probability
                    const [resultsMedicines, setResultsMedicines] = useState(medicinesSuggested)
                
            
                


                    //Dellay the search result for perfomance reasons
                    const debounceHandler = useCallback(

                        debounce((event) => {

                            const options = {
                                isCaseSensitive: false,
                                includeScore: true,
                                shouldSort: true,
                                includeMatches: false,
                                findAllMatches: false,
                                minMatchCharLength: 1,
                                location: 0,
                                threshold: 0.2,
                                distance: 3,
                                useExtendedSearch: true,
                                ignoreLocation: false,
                                ignoreFieldNorm: true,
                                keys: [
                                    {
                                        name: 'commercialName',
                                        weight: 7
                                    },
                                    {
                                        name: 'activeSubstances.activeSubstance.activeSubstance.description',
                                        weight: 2
                                    },
                                    {
                                        name: 'atcCode',
                                        weight: 1
                                    }
                                ]
                            }
                
                            //Make fuzzy search in all the exams
                            const fuseAllMedicines = new Fuse(dummyMedicines, options)
                            //Make search in most used exams
                            const queryMedicines = fuseAllMedicines.search(event)


                            //If the user has filled the input, then show the result of the search, if it is not filled show the most used
                            event.length ? setResultsMedicines(queryMedicines.map(x=>x.item)) : setResultsMedicines(medicinesSuggested)

                            setOpenSearchResults(true)
                        },200),[]

                    )
                    //Called when the user updates the input
                    const handleChange = (event) => { 
                        setOpenSearchResults(false)
                        debounceHandler(event.target.value)
                        setInput(event.target.value)
                    }
                    //if component loses focus closes autocomplete. Always show the selected exam in the input 
                    const onBlur = () =>{
            
                        setOpenSearchResults(false)
                        selectedMedication ? setInput(selectedMedication.commercialName + " " + selectedMedication.content + " " + selectedMedication.packageForm ) : setInput('')  ; setResultsMedicines(medicinesSuggested)
                    }
                    //When there is no input and the user clicks the component , show the most used exams
                    const onClickTextField = () =>{
                        !selectedMedication && setOpenSearchResults(true)
                    }
                    //Pick the medication to be checked and update the info of the selected medication (see comments)
                    const selectMedication = (x) => {
                        //The updated selected medication
                        setSelectedMedication(x)      
                        setOpenSearchResults(false)
                    }

                    const clear = (x) => {
                        resetMedicineData()
                    }





                    return (
                        <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={1}
                        >

                        

                            <Grid item xs={12}>
            
                                <form    
                                className="selectMedicine"                         
                                noValidate 
                                onSubmit={(event) => event.preventDefault()}
                                autoComplete="off"
                                >

                                
            
                                    <Grid item xs={12}>
                                        <Tooltip 
                                        title= {!helpActivatedTooltips ?
                                        <React.Fragment>
                                            <Typography  variant='h6' color="inherit">{!selectedMedication ? "Αναζήτηση φαρμάκου" : "Διαγραφή φαρμάκου"}</Typography>
                                            {selectedMedication ?
                                            <Typography variant='subtitle2' color="inherit">Για να διαγράψετε το φάρμακο που έχετε επιλέξει, κάντε κλικ στο εικονίδιο "Χ" που βρίσκεται στο δεξί μέρος του πεδίου.</Typography>
                                            :
                                            <Typography variant='subtitle2' color="inherit">Για να καταχωρίσετε τα φάρμακα που χρειάζεται ο ασθενής σας, κάντε κλικ στο πεδίο "φαρμακευτικό σκεύασμα". Θα δείτε μια λίστα με τα συνηθισμένα φάρμακα του ασθενούς, καθώς και αυτά που συνταγογραφείτε συχνά. Μπορείτε να επιλέξετε ένα από αυτά ή να αναζητήσετε ένα γράφοντας το.</Typography>
                                            }
                                        </React.Fragment> : ''
                                        } 
                                        >
                                            <TextField    
                                            spellCheck="false"
                                            onKeyDown={(event) => {
                                                if(event.key === "Escape" ){ setOpenSearchResults(false)}
                                            }}
                                            fullWidth  
                                            required
                                            onChange={handleChange} 
                                            label="Φαρμακευτικό σκεύσμα" 
                                            variant="outlined" 
                                            value={input}
                                            onClick={onClickTextField}
                                            onBlur={onBlur}
                                            
                                            InputProps={{
                                                readOnly:selectedMedication ? true : false,
                                                endAdornment:
                                                selectedMedication ?
                                                    <InputAdornment position="end">
                                                        <Tooltip title="Διαγραφή">
                                                            <IconButton
                                                                disabled={selectedMedication ? false : true}
                                                                aria-label="Εκκαθάριση"
                                                                onClick={()=>clear()}
                                                                edge="end"
                                                            >
                                                                <Cancel />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </InputAdornment>
                                                    :null
                                            }}
                                            />
                                        </Tooltip>
                                    </Grid> 
                                

                                {openSearchResults ?
                                resultsMedicines.length ?
                                <Paper elevation={3}  variant="outlined">
                                <List 
                                style={{ position: 'relative',overflow: 'auto', maxHeight:'50vh'}}
                                dense
                                >
                                    {resultsMedicines.map((x,index)=>
                                    <Tooltip
                                    title= {!helpActivatedTooltips ?
                                        <React.Fragment>
                                            {x.Group === "Προτεινόμενα φάρμακα . . ." ? 
                                            <>
                                            <Typography  variant='h6' color="inherit">Συχνά συνταγογραφούμενο φάρμακο</Typography>
                                            <Typography variant='subtitle2' color="inherit">Όταν επιλέγετε ένα φάρμακο, σας προτείνεται το κατάλληλο δοσολογικό σχήμα και διάγνωση για το φάρμακο που επιλέξατε. Αυτή η πρόταση βασίζεται σε έναν αλγόριθμο μηχανικής μάθησης που έχει εκπαιδευτεί με βάση τις προηγούμενες συνταγογραφήσεις σας.</Typography>
                                            </>
                                            :
                                            x.Group === "Χρόνια φάρμακα . . ." ? 
                                            <>
                                            <Typography  variant='h6' color="inherit">Φάρμακο ασθενή</Typography>
                                            <Typography variant='subtitle2' color="inherit">Όταν επιλέγετε ένα φάρμακο, σας προτείνεται ένα δοσολογικό σχήμα και μια διάγνωση με βάση τις προηγούμενες συνταγογραφήσεις σας.</Typography>
                                            </>
                                            :
                                            <>
                                            <Typography  variant='h6' color="inherit">Φάρμακο αναζήτησης</Typography>
                                            <Typography variant='subtitle2' color="inherit">Μετά την επιλογή του φαρμάκου, θα σας προταθεί ένα δοσολογικό σχήμα, το οποίο βασίζεται στα χαρακτηριστικά του φαρμάκου.</Typography>
                                            </>
                                            }
                                        </React.Fragment> : ''
                                        } 
                                    >
                                    <ListItem 
                                    dense
                                    onMouseDown={event => event.preventDefault()} 
                                    key={index} 
                                    button 
                                    onClick={()=>selectMedication(x)}>
                                        {x.Group === "Προτεινόμενα φάρμακα . . ." ? 
                                        <ListItemIcon>
                                            <History/>
                                        </ListItemIcon>
                                        :
                                        x.Group === "Χρόνια φάρμακα . . ." ?
                                        <ListItemIcon>
                                            <Accessibility/>
                                        </ListItemIcon>
                                        :
                                        <ListItemIcon>
                                            <Search/>
                                        </ListItemIcon>
                                        }
                                        <ListItemText  
                                        style={{wordBreak: 'break-all'}}
                                        secondaryTypographyProps={{variant:"caption", color:"textSecondary"}}
                                        primaryTypographyProps={{variant:"subtitle2", color:"textPrimary"}} 
                                        primary={x.commercialName + " " + x.content + " " + x.packageForm } 
                                        secondary={
                                            <React.Fragment>
                                            {(x.activeSubstances ? x.activeSubstances.activeSubstance.length ? x.activeSubstances.activeSubstance.filter(o=>o.mainActiveSubstance)[0].activeSubstance.description : x.activeSubstances.activeSubstance.activeSubstance.description : "") }
                                            <br></br>
                                            ATC:{x.atcCode}, Barcode:{x.barcode}, Τιμή:{x.retailPrice} €
                                            </React.Fragment>
                                            } />
                                        <ListItemAvatar>
                                        <Tooltip title="Απαιτείται η χρήση Θεραπευτικού πρωτοκόλλου.">
                                            <AvatarGroup max={3}>
                                                {x.onlyByProtocol && <Avatar>ΘΠ</Avatar>}
                                            </AvatarGroup>
                                        </Tooltip>
                                        </ListItemAvatar>
                                    </ListItem>
                                    </Tooltip>
                                    )}
                                </List>
                                </Paper>
                                :
                                <Typography color='textSecondary' variant='subtitle2' align='center'>
                                        Δεν βρέθηκε κανένα φαρμακευτικό σκεύασμα με το όνομα {input}.
                                </Typography>
                                :null
                                }

                                </form>
                            
                            </Grid>

                        

                        </Grid>
                    )
                }
                const Diagnosis = () => {

            
            
                
                    //The input of the user when searches for an exam
                    const [input, setInput] = useState(selectedDiagnosis.id ? selectedDiagnosis.title : '')
                    //Control the selection status (open / close) from search 
                    const [openSearchResults, setOpenSearchResults] = useState(false)
                    //The results of the fuzzy search sorted by probability
                    const [resultsDiagnosis, setResultsDiagnosis] = useState([])


                    //Dellay the search result for perfomance reasons
                    const debounceHandler = useCallback(

                    

                        debounce((event) => {
                            
                            const options = {
                            isCaseSensitive: false,
                            includeScore: true,
                            shouldSort: true,
                            includeMatches: false,
                            findAllMatches: true,
                            minMatchCharLength: 0,
                            location: 0,
                            threshold: 0.2,
                            distance: 100,
                            useExtendedSearch: true,
                            ignoreLocation: true,
                            ignoreFieldNorm: true,
                                keys: [
                                    {
                                        name: 'title',
                                        weight: 5
                                    },
                                    {
                                        name: 'description',
                                        weight: 3
                                    },
                                    {
                                        name: 'code',
                                        weight: 6
                                    }
                                ]
                            }

                            
                            

            
                            //Make fuzzy search in all the exams
                            const fuseAllDiagnoses = new Fuse(dummyDiagnoses, options)

                            //Select in what dataSet the search will be done
                            const queryAllGreek = fuseAllDiagnoses.search(convertEnglishToGreek(event))

                            const res = queryAllGreek.map(x=>x.item)
                            const withGroup = res.filter(diagnosis => diagnosis.Group !== undefined);
                            const withoutGroup = res.filter(diagnosis => diagnosis.Group === undefined);
                            const sortedDiagnoses = [...withGroup, ...withoutGroup];
                           
        
                            //If the user has filled the input, then show the result of the search, if it is not filled show the most used
                            event.length!==0 ? setResultsDiagnosis(sortedDiagnoses) : setResultsDiagnosis(selectedMedication.diagnoses ? selectedMedication.diagnoses : [])
                            setOpenSearchResults(true)
                        },200),[]

                        

                    )
                    //Called when the user updates the input
                    const handleChange = (event) => { 
                        setOpenSearchResults(false)
                        debounceHandler(event.target.value)
                        setInput(event.target.value)
                    }
                    //if component loses focus closes autocomplete. Always show the selected diagnosis in the input 
                    const onBlur = () =>{
                        setOpenSearchResults(false)
                        selectedDiagnosis ? setInput(selectedDiagnosis.title) : setInput("")

                    }
                    //When there is no input and the user clicks the component , show the most used diagnoses
                    const onClickTextField = () =>{

                    

                        if( input.length===0 && selectedDiagnosis.id===null){
                            
                        

                            setResultsDiagnosis(
                                selectedMedication?.suggested?.diagnosis
                                ? selectedMedication.suggested.diagnosis 
                                : dummyDiagnoses.slice(0,4)
                            )
                            setOpenSearchResults(true)
                            console.log("pop")
                        }
                    }
                    //When the user selects a diagnosis
                    const onSelect = (x) =>{
                        
                        //Move to the top of the page
                        window.scrollTo({top: 0, behavior: 'smooth'})

                        setSelectedDiagnosis(x)
                        setInput(x.title)
                        setOpenSearchResults(false)
                    }
                    const clearDiagnosis = () => {
                        setSelectedDiagnosis({
                            code: "",
                            description: "",
                            id: null,
                            insertDate: "",
                            notUpdPharCost: false,
                            onlyByProtocol: false,
                            onlyByProtocolAgeLimit: "",
                            title: "",
                            updateDate: ""
                        }) 
                        setInput('')
                    }


                    return (
                        <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={1}
                        >

                            <Grid item xs={12}>
                                <form  
                                className="diagnosisSelect"                           
                                noValidate 
                                onSubmit={(event) => event.preventDefault()}
                                autoComplete="off">
                
                                    <Grid item xs={12}>
                                        <Tooltip 
                                        title= {!helpActivatedTooltips ?
                                        <React.Fragment>
                                            <Typography  variant='h6' color="inherit">{!selectedDiagnosis.id ? "Αναζήτηση διάγνωσης" : "Διαγραφή διάγνωσης"}</Typography>
                                            {selectedDiagnosis.id  ?
                                            <Typography variant='subtitle2' color="inherit">Για να διαγράψετε τη διάδνωση που έχετε επιλέξει, κάντε κλικ στο εικονίδιο "Χ" που βρίσκεται στο δεξί μέρος του πεδίου.</Typography>
                                            :
                                            <Typography variant='subtitle2' color="inherit">Για να καταχωρήσετε τη διάγνωση, επιλέξτε το πεδίο διάγνωσης. Θα δείτε μια λίστα με προτεινόμενες διαγνώσεις με βάση το επιλεγμένο φάρμακο, τον ασθενή και τις συχνές διαγνώσεις σας. Μπορείτε να επιλέξετε μία από αυτές ή να αναζητήσετε μια διαφορετική διάγνωση πληκτρολογώντας την στο πεδίο.</Typography>
                                            }
                                        </React.Fragment> :''
                                        } 
                                        >
                                        <TextField    
                                        disabled={selectedMedication===null}  
                                        required
                                        error={selectedDiagnosis.id ? false : true}
                                        spellCheck="false"
                                        fullWidth
                                        onChange={handleChange} 
                                        onKeyDown={(event) => {
                                            if(event.key === "Escape" ){ setOpenSearchResults(false)}
                                        }}
                                        label="Διάγνωση" 
                                        variant="outlined" 
                                        value={input}
                                        onClick={onClickTextField}
                                        onBlur={onBlur}
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            readOnly:selectedDiagnosis.id ? true : false,
                                            endAdornment:
                                            selectedDiagnosis.id ?
                                                <InputAdornment position="end">
                                                    <Tooltip title="Διαγραφή">
                                                        <IconButton
                                                        disabled={selectedDiagnosis.id ? false : true}
                                                            aria-label="Εκκαθάριση"
                                                            onClick={()=>clearDiagnosis()}
                                                            edge="end"
                                                        >
                                                            <Cancel />
                                                        </IconButton>
                                                    </Tooltip>
                                                </InputAdornment> : null
                                        }}
                                        />
                                    </Tooltip>
                                    </Grid> 
                            
                                {openSearchResults && resultsDiagnosis.length ?
                                <Paper className={classes.papper}  elevation={3}  variant="outlined">
                                <List 
                                style={{ position: 'relative',overflow: 'auto', maxHeight:'50vh'}}
                                dense
                                >
                                    {resultsDiagnosis.map(x=>
                                    <Tooltip
                                    title= {!helpActivatedTooltips ?
                                        <React.Fragment>
                                            {x.Group === 0 ? 
                                            <>
                                            <Typography variant='subtitle2' color="inherit">Διάγνωση που χρησιμοποιείτε συχνά</Typography>
                                            </>
                                            :
                                            x.Group === 1 ? 
                                            <>
                                            <Typography variant='subtitle2' color="inherit">Διάγνωση που σχετίζεται με το επιλεγμένο φάρμακο.</Typography>
                                            </>
                                            :
                                            <>
                                            <Typography variant='subtitle2' color="inherit">Γενική διάγνωση από την αναζήτηση που πραγματοποιήσατε</Typography>
                                            </>
                                            }
                                        </React.Fragment> : ''
                                        } 
                                    >
                                    <ListItem 

                                    dense
                                    onMouseDown={event => event.preventDefault()} 
                                    key={x.id} 
                                    button 
                                    onClick={()=>onSelect(x)}>
                                        {x.Group === 1 || x.Group === "Προτεινόμενες διαγνώσεις . . ." ? 
                                        <ListItemIcon>
                                            <FaPills/>
                                        </ListItemIcon>
                                        :
                                        x.Group === 2 ? 
                                        <ListItemIcon>
                                            <Description/>
                                        </ListItemIcon>
                                        :
                                        x.Group === 0 ? 
                                        <ListItemIcon>
                                            <History/>
                                        </ListItemIcon>
                                        :
                                        <ListItemIcon>
                                            <Search/>
                                        </ListItemIcon>
                                        }
                                        <Grid container alignItems="center" spacing={2} wrap="nowrap"> {/* wrap="nowrap" */}
                                        <Grid item xs> {/* xs for ListItemText to take available space */}
                                        <ListItemText
                                            style={{ wordBreak: 'break-all' }}
                                            primary={x.code + " " + x.title}
                                            secondary={x.description}
                                        />
                                        </Grid>
                                        <Grid item>
                                        <ListItemAvatar>
                                            <Tooltip title="Απαιτείται η χρήση Θεραπευτικού πρωτοκόλλου.">
                                            <AvatarGroup max={1}>
                                                {x.onlyByProtocol && <Avatar style={{ whiteSpace: 'nowrap' }}>ΘΠ</Avatar>}
                                            </AvatarGroup>
                                            </Tooltip>
                                        </ListItemAvatar>
                                        </Grid>
                                    </Grid>
                                    </ListItem>
                                    </Tooltip>
                                    )}
                                </List>
                                </Paper>
                                :
                                openSearchResults && input.length ?
                                <Typography color='textSecondary' variant='subtitle2' align='center'>
                                Δεν βρέθηκε διάγνωση με το όνομα {input}.
                                </Typography>
                                :
                                null
                        
                                }
                                </form>
                            </Grid>
                        </Grid>
                    )
                }    
                const Quantity = () =>{
        
                    // Quantity options for medication prescriptions
                    const quantityOptions = [
                        // Chronic treatment quantities (1-10)
                        {
                        id: "1",
                        name: "1 συσκευασία",
                        Group: "Χρόνια Θεραπεία"
                        },
                        {
                        id: "2",
                        name: "2 συσκευασίες",
                        Group: "Χρόνια Θεραπεία"
                        },
                        {
                        id: "3",
                        name: "3 συσκευασίες",
                        Group: "Χρόνια Θεραπεία"
                        },
                        {
                        id: "4",
                        name: "4 συσκευασίες",
                        Group: "Χρόνια Θεραπεία"
                        },
                        {
                        id: "5",
                        name: "5 συσκευασίες",
                        Group: "Χρόνια Θεραπεία"
                        },
                        {
                        id: "6",
                        name: "6 συσκευασίες",
                        Group: "Χρόνια Θεραπεία"
                        },
                        {
                        id: "7",
                        name: "7 συσκευασίες",
                        Group: "Χρόνια Θεραπεία"
                        },
                        {
                        id: "8",
                        name: "8 συσκευασίες",
                        Group: "Χρόνια Θεραπεία"
                        },
                        {
                        id: "9",
                        name: "9 συσκευασίες",
                        Group: "Χρόνια Θεραπεία"
                        },
                        {
                        id: "10",
                        name: "10 συσκευασίες",
                        Group: "Χρόνια Θεραπεία"
                        },
                        
                        // Single dose quantities (>10)
                        {
                        id: "11",
                        name: "15 συσκευασίες",
                        Group: "Μονοδοσιακό"
                        },
                        {
                        id: "12",
                        name: "20 συσκευασίες",
                        Group: "Μονοδοσιακό"
                        },
                        {
                        id: "13",
                        name: "25 συσκευασίες",
                        Group: "Μονοδοσιακό"
                        },
                        {
                        id: "14",
                        name: "30 συσκευασίες",
                        Group: "Μονοδοσιακό"
                        },
                        {
                        id: "15",
                        name: "40 συσκευασίες",
                        Group: "Μονοδοσιακό"
                        },
                        {
                        id: "16",
                        name: "50 συσκευασίες",
                        Group: "Μονοδοσιακό"
                        }
                    ];


                    // Quantity state
                    const selectedQuantity = useStore(state => state.selectedQuantity);
                    const setSelectedQuantity = useStore(state => state.setSelectedQuantity);
                    const [options, setOptions] = useState(quantityOptions)
                    const [inputValueQuantity, setInputValueQuantity] = useState(selectedQuantity ? selectedQuantity.name : '');


                    useEffect(()=> {
        
    
                        if(selectedMedication && selectedMedication.quantity){
                            setSelectedQuantity (quantityOptions.find(xx=>xx.id === selectedMedication.quantity))
                  
                        }
             
                            
                        

                    },[]) 
        

                    const handleChange = (event, newValue) => {
                        setSelectedQuantity(newValue)
                    }
        
                    const filterOptions = createFilterOptions({
                        matchFrom: 'start',
                    })


                    return(
                        <Tooltip
                        title= {!helpActivatedTooltips ?
                        <React.Fragment>
                            <Typography variant='subtitle2' color="inherit">Συμπληρώστε την ποσότητα των φαρμακευτικών σκευασμάτων που θέλετε να συνταγογραφήσετε στον ασθενή. Η συνταγή θα λάβει την ένδειξη "χρόνια θεραπεία" εάν η ποσότητα είναι από 1 έως 10. Εάν είναι πάνω από 10, θα λάβει την ένδειξη "μονοδόσιακο".</Typography>
                        </React.Fragment>
                        :''} 
                        >
                        <Autocomplete
                        disableClearable
                        groupBy={(option) => option.Group}
                        value={selectedQuantity}
                        inputValue={inputValueQuantity}
                        onInputChange={(event, newInputValue) => {
                            setInputValueQuantity(newInputValue)
                        }}
                        onChange={handleChange}
                        noOptionsText="Επιλέξτε μια ποσότητα από την λίστα"
                        style={{ width: 250 }}
                        id="Quantity"
                        filterOptions={filterOptions}
                        options={options}
                        getOptionLabel={(option) => option.name }
                        renderInput={(params) => <TextField {...params} error={selectedQuantity.id ? false : true} required label="Ποσότητα" variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }} />}
                        />
                        </Tooltip>
                    )
                }
                const Dose = () =>{

                    const dosesData = [
                        {
                        Group: 'Δόση',
                        name: '0.25 δισκίου',
                        id: 0.25
                        },
                        {
                        Group: 'Δόση',
                        name: '0.5 δισκίου',
                        id: 0.5
                        },
                        {
                        Group: 'Δόση',
                        name: '1 δισκίο',
                        id: 1
                        },
                        {
                        Group: 'Δόση',
                        name: '1.5 δισκίο',
                        id: 1.5
                        },
                        {
                        Group: 'Δόση',
                        name: '2 δισκία',
                        id: 2
                        },
                        {
                        Group: 'Δόση',
                        name: '2.5 δισκία',
                        id: 2.5
                        },
                        {
                        Group: 'Δόση',
                        name: '3 δισκία',
                        id: 3
                        }
                    ]

                    // Dose state
                    const selectedDose = useStore(state => state.selectedDose);
                    const setSelectedDose = useStore(state => state.setSelectedDose);
                    const [inputValueDose, setInputValueDose] = useState(selectedDose ? selectedDose.name : '')             
                
                    useEffect(()=> {
        
    
                        if(selectedMedication && selectedMedication.dose){
                            setSelectedDose (dosesData.find(xx=>xx.id === selectedMedication.dose))
                  
                        }
             
                            
                        

                    },[]) 

                    const filterOptions = createFilterOptions({
                        matchFrom: 'start',
                    });

                    return(
                        <Tooltip
                        title= {!helpActivatedTooltips ?
                        <React.Fragment>
                            <Typography variant='subtitle2' color="inherit">Εισαγάγετε τη δόση του φαρμάκου που θέλετε να συνταγογραφήσετε στον ασθενή.</Typography>
                        </React.Fragment>
                        :''} 
                        >
                        <Autocomplete
                        disableClearable
                        groupBy={(option) => option.Group}
                        value={selectedDose}
                        inputValue={inputValueDose}
                        onInputChange={(event, newInputValue) => {
                            setInputValueDose(newInputValue)
                        }}
                        onChange={(event, newValue) => {
                            setSelectedDose(newValue)
                        }}
                        noOptionsText="Επιλέξτε μια δόση από την λίστα"
                        style={{ width: 250 }}
                        id="Dose"
                        filterOptions={filterOptions}
                        options={dosesData}
                        getOptionLabel={(dosesData) => dosesData.name }
                        renderInput={(params) => <TextField {...params} required error={selectedDose.id ? false : true} label="Δόση" variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }} />}
                        />  
                        </Tooltip>
                    )
                }
                const Frequency = () =>{

                    const frequencies = [
                        {
                        id: 1,
                        name: "1 φορά την ημέρα",
                        Group: "Συχνότητες"
                        },
                        {
                        id: 2,
                        name: "2 φορές την ημέρα",
                        Group: "Συχνότητες"
                        },
                        {
                        id: 3,
                        name: "3 φορές την ημέρα",
                        Group: "Συχνότητες"
                        },
                        {
                        id: 4,
                        name: "4 φορές την ημέρα",
                        Group: "Συχνότητες"
                        },
                        {
                        id: 5,
                        name: "Κάθε πρωί",
                        Group: "Συχνότητες"
                        },
                        {
                        id: 6,
                        name: "Κάθε βράδυ",
                        Group: "Συχνότητες"
                        },
                        {
                        id: 7,
                        name: "Κάθε 4 ώρες",
                        Group: "Συχνότητες"
                        },
                        {
                        id: 8,
                        name: "Κάθε 6 ώρες",
                        Group: "Συχνότητες"
                        },
                        {
                        id: 9,
                        name: "Κάθε 8 ώρες",
                        Group: "Συχνότητες"
                        },
                        {
                        id: 10,
                        name: "Κάθε 12 ώρες",
                        Group: "Συχνότητες"
                        },
                        {
                        id: 11,
                        name: "1 φορά την εβδομάδα",
                        Group: "Συχνότητες"
                        },
                        {
                        id: 12,
                        name: "2 φορές την εβδομάδα",
                        Group: "Συχνότητες"
                        },
                        {
                        id: 13,
                        name: "3 φορές την εβδομάδα",
                        Group: "Συχνότητες"
                        },
                        {
                        id: 14,
                        name: "Κατά την κρίση του ασθενούς",
                        Group: "Συχνότητες"
                        },
                        {
                        id: 15,
                        name: "Σε περίπτωση πόνου",
                        Group: "Συχνότητες"
                        },
                        {
                        id: 16,
                        name: "Πριν το φαγητό",
                        Group: "Συχνότητες"
                        },
                        {
                        id: 17,
                        name: "Μετά το φαγητό",
                        Group: "Συχνότητες"
                        },
                        {
                        id: 18,
                        name: "1 φορά το μήνα",
                        Group: "Συχνότητες"
                        }
                    ];
                    

                    const [inputValueFrequency, setInputValueFrequency] = useState('')
                    // Frequency state
    const selectedFrequency = useStore(state => state.selectedFrequency);
    const setSelectedFrequency = useStore(state => state.setSelectedFrequency);       
        

                    const filterOptions = createFilterOptions({
                        matchFrom: 'start',
                    });

                    return(
                        <Tooltip
                        title= {!helpActivatedTooltips ?
                        <React.Fragment>
                            <Typography variant='subtitle2' color="inherit">Εισαγάγετε τη συχνότητα δόσης του φαρμάκου που θέλετε να συνταγογραφήσετε στον ασθενή.</Typography>
                        </React.Fragment>
                        :''} 
                        >
                        <Autocomplete
                        disableClearable
                        groupBy={(option) => option.Group}
                        value={selectedFrequency}
                        inputValue={inputValueFrequency}
                        onInputChange={(event, newInputValue) => {
                            setInputValueFrequency(newInputValue)
                        }}
                        onChange={(event, newValue) => {
                            setSelectedFrequency(newValue);
                        }}
                        noOptionsText="Επιλέξτε μια συχνότητα από την λίστα"
                        style={{ width: 250 }}
                        id="Frequency"
                        filterOptions={filterOptions}
                        options={frequencies}
                        getOptionLabel={(frequencies) => frequencies.name }
                        renderInput={(params) => <TextField {...params} error={selectedFrequency.id ? false : true}  required label="Συχνότητα" variant="outlined" 
                        InputLabelProps={{
                            shrink: true,
                        }}/>}
                        />
                        </Tooltip>

                        
                    )
                }
                const Days = () =>{
            
                    // Days state
    const selectedDays = useStore(state => state.selectedDays);
    const setSelectedDays = useStore(state => state.setSelectedDays);        
                    const [options, setOptions] = useState([])
                    const [inputValueDays, setInputValueDays] = useState('');

            
                    

                    //Define the frequency range ("options")
                    useEffect(()=> {
        
                        let list  = []
                        for (var i = 1; i <= 60; i++) {
                            list.push({
                                Group:'Διάρκεια Θεραπείας',
                                name:`${i}  ημέρες`,
                                id:i
                            });
                        }
                        



                        setOptions(list)
                        setSelectedDays (list[29])
                            
                        

                    },[]) 





                    const filterOptions = createFilterOptions({
                        matchFrom: 'start',
                    });

                    const onChange = (event, newValue) =>{ 
                        setSelectedDays(newValue)                   
                    }

    

                    return(
                        <Tooltip
                        title= {!helpActivatedTooltips ?
                        <React.Fragment>
                            <Typography variant='subtitle2' color="inherit">Εισαγάγετε τη διάρκεια θεραπείας. Εάν η συνταγή είναι επαναλαμβανόμενη ή συνταγογραφείτε ως ειδικευόμενος ή αγροτικός γιατρός, η μέγιστη διάρκεια θεραπείας είναι 30 ημέρες.</Typography>
                        </React.Fragment>
                        :''} 
                        >
                        <Autocomplete
                        disableClearable
                        groupBy={(option) => option.Group}
                        value={selectedDays}
                        inputValue={inputValueDays}
                        onInputChange={(event, newInputValue) => {
                            setInputValueDays(newInputValue)
                        }}
                        onChange={onChange}
                        noOptionsText="Επιλέξτε ημέρες θεραπείας από την λίστα"
                        id="Days"
                        filterOptions={filterOptions}
                        options={options}
                        getOptionLabel={(option) => option.name }
                        style={{ width: 250 }}
                        renderInput={(params) => <TextField {...params} required label="Ημέρες Θεραπείας" variant="outlined" 
                        InputLabelProps={{
                            shrink: true,
                        }}/>}
                        />
                        </Tooltip>
                    )
                }
                const Repeat = () =>{

                    const repeats = [
                        {
                        Group: 'Επανάληψη',
                        id: 1,
                        name: 'ΑΠΛΗ'
                        },
                        {
                        Group: 'Επανάληψη',
                        id: 2,
                        name: '2ΜΗΝΗ'
                        },
                        {
                        Group: 'Επανάληψη',
                        id: 3,
                        name: '3ΜΗΝΗ'
                        },
                        {
                        Group: 'Επανάληψη',
                        id: 4,
                        name: '4ΜΗΝΗ'
                        },
                        {
                        Group: 'Επανάληψη',
                        id: 5,
                        name: '5ΜΗΝΗ'
                        },
                        {
                        Group: 'Επανάληψη',
                        id: 6,
                        name: '6ΜΗΝΗ'
                        }
                    ];
                    const repeatIntervals = [
                    {
                        id: 1,
                        Group: 'Διάστημα',
                        intervalDescription: '1 ΜΗΝΑΣ',
                        isActive: true
                    },
                    {
                        id: 2,
                        Group: 'Διάστημα',
                        intervalDescription: '2 ΜΗΝΕΣ',
                        isActive: true
                    }
                    ];

                    // Repeat state
    const selectedRepeat = useStore(state => state.selectedRepeat);
    const setSelectedRepeat = useStore(state => state.setSelectedRepeat);       
                    const [inputValueRepeat, setInputValueRepeat] = useState('');
                    
                
                // Repeat state
    const selectedInterval = useStore(state => state.selectedInterval);
    const setSelectedInterval = useStore(state => state.setSelectedInterval);      
                    const [inputValueInterval, setInputValueInterval] = useState('');
        
                    useEffect(()=> {
        
    
                        if(selectedMedication && selectedMedication.repeat){
                            setSelectedRepeat (repeats[selectedMedication.repeat-1])
                            setSelectedInterval(repeatIntervals[0])
                        }
                        else{
                            setSelectedRepeat (repeats[0])
                        }
                            
                        

                    },[]) 

                

                    const filterOptions = createFilterOptions({
                        matchFrom: 'start',
                    })

                

                    return(
                        <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"   
                        spacing={1}
                        >
                            <Grid item>
                                <Tooltip
                                title= {!helpActivatedTooltips ?
                                <React.Fragment>
                                    <Typography variant='subtitle2' color="inherit">Εισαγάγετε την επαναληψιμότητα της συνταγής. Για γιατρούς χωρίς ειδικότητα, η επαναληψιμότητα είναι έως τρεις μήνες, εκτός από περιπτώσεις γνωμάτευσης. Για ειδικευόμενους γιατρούς, η επαναληψιμότητα είναι ένας μήνας, εκτός από περιπτώσεις γνωμάτευσης. Εάν η διάρκεια θεραπείας είναι μεγαλύτερη από 30 ημέρες, η επαναληψιμότητα είναι μέγιστο δύο.</Typography>
                                </React.Fragment>
                                :''} 
                                >
                                <Autocomplete
                                required
                                disableClearable
                                groupBy={(option) => option.Group}
                                value={selectedRepeat}
                                inputValue={inputValueRepeat}
                                onInputChange={(event, newInputValue) => {
                                    setInputValueRepeat(newInputValue)
                                }}
                                onChange={(event, newValue) => {
                                    setSelectedRepeat(newValue)
                                }}
                                noOptionsText="Επιλέξτε επανάληψη από την λίστα"
                                id="Repeat"
                                filterOptions={filterOptions}
                                options={repeats}
                                getOptionLabel={(repeats) => repeats.name }
                                style={{ width: 250 }}
                                renderInput={(params) => <TextField {...params} error={selectedRepeat.id ? false : true} required label="Επαναληψιμότητα" variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }} />}
                                />
                                </Tooltip>
                            </Grid>
                            <Grid item>
                                {selectedRepeat.id!==1 &&
                                <Tooltip
                                title= {!helpActivatedTooltips ?
                                <React.Fragment>
                                    <Typography variant='subtitle2' color="inherit">Σε περίπτωση επαναληψιμότητας συνταγής, πρέπει να εισάγετε την περίοδο επανάληψης.</Typography>
                                </React.Fragment>
                                :''} 
                                >
                                <Autocomplete
                                disableClearable
                                groupBy={(l) => l.Group}
                                value={selectedInterval}
                                inputValue={inputValueInterval}
                                onInputChange={(event, newInputValue) => {
                                    setInputValueInterval(newInputValue)
                                }}
                                onChange={(event, newValue) => {
                                    setSelectedInterval(newValue)
                                }}
                                noOptionsText="Επιλέξτε την περίοδο επανάληψης από την λίστα"
                                id="Interval"
                                options={repeatIntervals}
                                getOptionLabel={(l) => l.intervalDescription }
                                style={{ width: 250 }}
                                renderInput={(params) => <TextField {...params} error={selectedInterval.id ? false : true} required label="Περίοδος Επανάληψης" variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }} />}
                                />
                                </Tooltip>}
                            </Grid>
                        </Grid>
                    )
                }
                const CopaymentAndDiseaseAndZeroCase = () =>{


                    const percentages = [
                        {
                        id: 1,
                        name: '0',
                        description: '0%'
                        },
                        {
                        id: 3,
                        name: '25',
                        description: '25%'
                        },
                        {
                        id: 4,
                        name: '100',
                        description: '100%'
                        }
                    ];

                    const [inputValueCopayment, setInputValueCopayment] = useState('')
        
    // Copayment state
    const selectedCopayment = useStore(state => state.selectedCopayment);
    const setSelectedCopayment = useStore(state => state.setSelectedCopayment);
            


                
                    useEffect(()=> {       

                        setSelectedCopayment(percentages[1])

                    },[]) 



                
                    return(
                        <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={1}
                        >

            
                            <Grid className="repeteability" item>
                            <Tooltip
                            title= {!helpActivatedTooltips ?
                            <React.Fragment>
                                <Typography variant='subtitle2' color="inherit">Εισαγάγετε την συμμετοχή του ασθενή στην θεραπεία. Η συμμετοχή καθορίζεται από το ΕΚΑΣ, την ασφάλεια του ασθενή, την περίπτωση μηδενικής συμμετοχής και την πιθανή ασθένεια που έχετε επιλέξει. Η συμμετοχή προτείνεται από το σύστημα, αλλά εσείς είστε υπεύθυνοι για την τελική απόφαση.</Typography>
                            </React.Fragment>
                            :''} 
                            >
                                <Autocomplete
                                disableClearable
                                value={selectedCopayment}
                                inputValue={inputValueCopayment}
                                onInputChange={(event, newInputValue) => {
                                    setInputValueCopayment(newInputValue)
                                }}
                                onChange={(event, newValue) => {
                                    setSelectedCopayment(newValue);
                                }}
                                noOptionsText="Επιλέξτε ένα ποσοστό από την λίστα"
                                id="Copayment"
                                options={percentages}
                                getOptionLabel={(percentages) => percentages.description }
                                style={{ width: 250 }}
                                renderInput={(params) => <TextField {...params} error={selectedCopayment.id ? false : true} required label="Συμμετοχή" variant="outlined" 
                                InputLabelProps={{
                                    shrink: true,
                                }}/>}
                                />
                                </Tooltip>
                            </Grid>

            
                        </Grid>
                    )
                }
                const MediacationInfoDialog = () => {
                    

                    return (
                        <>

                            {(selectedMedication) &&
                            <Tooltip
                            title= {!helpActivatedTooltips ?
                            <React.Fragment>
                                <Typography variant='subtitle2' color="inherit">Κάνοντας κλικ στο κουμπί "Πληροφορίες φαρμάκου", θα έχετε πρόσβαση σε όλες τις πληροφορίες για το φάρμακο, όπως τις παρέχει ο ΕΟΦ.</Typography>
                            </React.Fragment>
                            :''} 
                            >
                            <Button
                            className="prescriptionInfo"
                            variant="outlined" 
                            style={{marginRight:'1rem', marginTop:'1rem'}}
                            color="primary"
                            aria-label="Πληροφορίες φαρμάκου"
                            onClick={()=>   setDemoMessage({
                                status:true,
                                severity:"info",
                                description: "το κουμπί εμφανίζει το εγκεκριμένο από τον ΕΟΦ, φυλλάδιο χαρακτηριστικών του φαρμάκου"
                            })}
                            >
                                ΠΛΗΡΟΦΟΡΙΕΣ ΦΑΡΜΑΚΟΥ
                            </Button>
                            </Tooltip>}

                            {selectedMedication &&
                            <Tooltip
                            title= {!helpActivatedTooltips ?
                            <React.Fragment>
                                <Typography variant='subtitle2' color="inherit">Κάνοντας κλικ στο κουμπί "Πληροφορίες ΕΟΠΥΥ", θα εμφανιστούν βασικές πληροφορίες για το φάρμακο από τον ΕΟΠΥΥ, καθώς και το ιστορικό συνταγογραφήσεων του στον ασθενή. Εάν υπάρχει υποχρεωτική ενημέρωση για το φάρμακο, οι πληροφορίες φαρμάκου θα ανοίξουν αυτόματα και το χρώμα του κουμπιού θα γίνει κόκκινο.</Typography>
                            </React.Fragment>
                            :''} 
                            >
                            <Button
                            className="prescriptionInfo"
                            variant="outlined" 
                            style={{marginRight:'1rem', marginTop:'1rem'}}
                            color="primary"
                            aria-label="Πληροφορίες φαρμάκου"
                            onClick={()=>   setDemoMessage({
                                status:true,
                                severity:"info",
                                description: "το κουμπί εμφανίζει πληροφορίες για το φάρμακο από τον ΕΟΠΥΥ, όπως αντενδείξεις, στόχο γενόσημου , SPC φαρμάκου, και ιστορικό συνταγογράφησης στον ασθενή."
                            })}
                            >
                                ΠΛΗΡΟΦΟΡΙΕΣ ΕΟΠΥΥ
                            </Button>
                            </Tooltip>}

                        </>
                        
                    )
                }
                const VisitProtocols = () =>{

        

                    return(     
                        
                        <Button style={{marginRight:'1rem', marginTop:'1rem'}} variant="outlined" color="primary" className="TP" onClick={()=>   setDemoMessage({
                            status:true,
                            severity:"info",
                            description: "το κουμπί εμφανίζει τα καταχωρημένα Θ.Π. της επίσκεψης"
                        })} >
                            Θ.Π. ΕΠΙΣΚΕΨΗΣ     
                        </Button>  
            
                        
                    )
                }
                const Protocols = () =>{

            

                    const [protocolsDialog, setProtocolsDialog] = useState(false);


                    //Open / Close the Treatment protocols part
                    const handleToggleDialog =()=>{ 
                        setProtocolsDialog(prev=>!prev)
                    }
        



                

                    return (
                        <>
                            <Tooltip
                            title= {!helpActivatedTooltips ?
                            <React.Fragment>
                                <Typography variant='subtitle2' color="inherit" >Η διαδικασία Θ.Π. γίνεται αυτόματα για τα περισσότερα φάρμακα και διαγνώσεις. Αν δεις το κουμπί "Οδηγός Θ.Π." μπλε, όλα είναι έτοιμα και δεν χρειάζεται να κάνεις τίποτα άλλο. Αν όμως το κουμπί είναι κόκκινο, τότε θα πρέπει να ολοκληρώσεις εσύ τη διαδικασία των θεραπευτικών πρωτοκόλλων.</Typography>
                            </React.Fragment>
                            :''}
                            >
                            <Button style={{marginRight:'1rem', marginTop:'1rem'}} variant="outlined"  className="TP" color="primary"  onClick={()=> handleToggleDialog()}  >
                                ΟΔΗΓΟΣ Θ.Π.      
                            </Button>
                        </Tooltip>

            

            



                        

                        <Dialog fullWidth maxWidth="sm" onClose={handleToggleDialog} open={protocolsDialog}>
                        
                            <DialogTitle >                         
                                Οδηγός Θεραπευτικών Πρωτοκόλλων Συνταγογράφησης
                            </DialogTitle>

                            <DialogContent dividers> 
                                <Typography variant='subtitle2' color='textSecondary'>
                                {((selectedMedication && selectedMedication.onlyByProtocol) || (selectedDiagnosis && selectedDiagnosis.onlyByProtocol)) ? "Η χρήση θεραπευτικού πρωτοκόλλου είναι υποχρεωτική. Θα γίνει προσπάθεια επανάληψης ή επαναδημιουργίας του απαραίτητου θεραπευτικού πρωτοκόλλου για την καταχώρηση του φαρμάκου και της διάγνωσης: Θεραπευτικό πρωτόκολλο: ....." : "Η χρήση θεραπευτικού πρωτοκόλλου δεν είναι υποχρεωτική για το επιλεγμένο φάρμακο και διάγνωση." }
                                </Typography>
                            </DialogContent>

                            <DialogActions>
                                <Tooltip
                                title= {!helpActivatedTooltips ?
                                <React.Fragment>
                                    <Typography variant='subtitle2' color="inherit">Eπιλέξτε "ΕΠΙΣΤΡΟΦΗ" για να επιστρέψετε στη σελίδα της συνταγογράφησης</Typography>
                                </React.Fragment>
                                :''} 
                                >
                                <Button variant="outlined" color='secondary'  onClick={handleToggleDialog} >
                                    ΕΠΙΣΤΡΟΦΗ         
                                </Button>
                                </Tooltip>
                                <Tooltip
                                title= {!helpActivatedTooltips ?
                                <React.Fragment>
                                    <Typography variant='subtitle2' color="inherit">Eπιλέξτε "ΚΑΤΑΧΩΡΗΣΗ Θ.Π." για να μεταφερθείτε στη σελίδα της συνταγογράφησης</Typography>
                                </React.Fragment>
                                :''} 
                                >
                                <Button variant="outlined" color='primary' className="TP" onClick={()=>   setDemoMessage({
                                status:true,
                                severity:"info",
                                description: "το κουμπί σας μεταφέρει στη σελίδα των θεραπευτικών πρωτοκόλλων, όπου μπορείτε να καταχωρήσετε χειροκίνητα οποιοδήποτε θεραπευτικό πρωτόκολλο."
                                })}   >
                                    ΚΑΤΑΧΩΡΗΣΗ Θ.Π.         
                                </Button>
                                </Tooltip>
                                <Tooltip
                                title= {!helpActivatedTooltips ?
                                <React.Fragment>
                                    <Typography variant='subtitle2' color="inherit">Eπιλέξτε "ΑΝΑΝΕΩΣΗ Θ.Π." για να ξαναδημιουργηθεί το προτεινόμενο ληγμένο Θ.Π. με τις τελευταιες παραμέτρους</Typography>
                                </React.Fragment>
                                :
                                'Ανανέωση προτεινόμενου Θ.Π. με τις ίδιες παραμέτρους.'} 
                                >
                                <Button color='primary'onClick={()=>   setDemoMessage({
                                status:true,
                                severity:"info",
                                description: "σε περίπτωση προβλήματος με την αυτόματη υποβοήθηση θεραπευτικών πρωτοκόλλων, αυτό το κουμπί σάς επιτρέπει να ανανεώσετε ή να δημιουργήσετε εκ νέου το προτεινόμενο, ληγμένο θεραπευτικό πρωτόκολλο με τις πιο πρόσφατες παραμέτρους"
                                })}   >
                                    ΑΝΑΝΕΩΣΗ Θ.Π.       
                                </Button>
                                </Tooltip>
                            </DialogActions>

                        </Dialog>

                    </>
                    )
                }
                const MedicationComment = () => {
            

                        //Transient comment value
                        const [comment, setComment] = useState("")

                    const handleChange = event => {
                        setComment(event.target.value);
                    }

        
            
                    return (
                        <Tooltip
                        title= {!helpActivatedTooltips ?
                        <React.Fragment>
                            <Typography variant='subtitle2' color="inherit">Εισάγετε ένα προαιρετικό σχόλιο για τη θεραπεία.</Typography>
                        </React.Fragment>
                        :''} 
                        >
                        <TextField
                        style={{ width: 250 }}
                        id="comment"
                        label="Σχόλια Θεραπείας"
                        value={comment}
                        inputProps={{ maxLength: 100 }}
                        onChange={handleChange}
                        variant="outlined"
                        />
                        </Tooltip>
                    )
                }
                const PrescriptionComment = () => {
            
                    //Transient comment value
                    const [comment, setComment] = useState("")



                    const handleChange = event => {
                        setComment(event.target.value);
                    }

                    
        
            
                    return (
                        <Tooltip
                        title= {!helpActivatedTooltips ?
                        <React.Fragment>
                            <Typography variant='subtitle2' color="inherit">Εισάγετε ένα προαιρετικό σχόλιο για τη συναταγή, στην οποία θα ενταχθει το φάρμακο που επιλέξατε.</Typography>
                        </React.Fragment>
                        :''} 
                        >
                        <TextField
                        style={{ width: 250 }}
                        id="comment"
                        label="Σχόλια συνταγής."
                        value={comment}
                        onChange={handleChange}
                        variant="outlined"
                        inputProps={{ maxLength: 100 }}
                        />
                        </Tooltip>
                    )
                }
                const RegisterMedicine = () => {

        
                    const selectedMedication = useStore(state => state.selectedMedication);
                    const selectedDiagnosis = useStore(state => state.selectedDiagnosis);
                    const selectedQuantity = useStore(state => state.selectedQuantity);
                    const selectedDose = useStore(state => state.selectedDose);
                    const selectedFrequency = useStore(state => state.selectedFrequency);
                    const selectedDays = useStore(state => state.selectedDays);
                    const selectedRepeat = useStore(state => state.selectedRepeat);
                    const selectedCopayment = useStore(state => state.selectedCopayment);
                    const medicationComment = useStore(state => state.medicationComment);
                    const prescriptionComment = useStore(state => state.prescriptionComment);
                    const addPrescription  = useStore(state => state.addPrescription );
                    const resetMedicineData = useStore(state => state.resetMedicineData);
                    const prescriptions = useStore(state => state.prescriptions);
                    const setDemoDialog = useDemoStore(state => state.setDemoDialog)
                  
                
                   
                   
                  

                    



        
                    
                    const createNewPrescription = () => {
                        if (!selectedMedication || !selectedDiagnosis.id) return;

                        const newMedicine = {
                            MedicationInfo: {
                            barcode: selectedMedication.barcode,
                            commercialName: selectedMedication.commercialName,
                            content: selectedMedication.content,
                            isDeliverable: true,
                            drug: true,
                            doseUnit: selectedMedication.doseUnit
                            },
                            Diagnosis: {
                            title: selectedDiagnosis.title,
                            code: selectedDiagnosis.code
                            },
                            Quantity: selectedQuantity,
                            Dose: selectedDose,
                            Frequency: selectedFrequency,
                            Days: selectedDays,
                            Repeat: selectedRepeat,
                            Copayment: selectedCopayment,
                            exitIfet: {
                            status: false,
                            ifetForm: ""
                            },
                            ChronicDisease: false,
                            month: false,
                            twoMonth: false,
                            Monodose: false,
                            protocol: {
                            protocolMandatory: selectedMedication.onlyByProtocol || selectedDiagnosis.onlyByProtocol
                            },
                            comments: {
                            medication: medicationComment,
                            prescription: prescriptionComment
                            }
                        }


                        const nonSentPrescription = prescriptions.find(x=>x.sent===false)
                        const sentPrescriptions = prescriptions.filter(x=>x.sent)

                        const medicationExists = prescriptions.some(prescriptionn => 
                            prescriptionn.medicines.some(medicine => 
                                medicine.MedicationInfo.barcode === selectedMedication.barcode
                            )
                        );

                        if (medicationExists) {
                            setDemoMessage({
                                status:true,
                                severity:"info",
                                description: "Το φάρμακο αυτό είναι ήδη καταχωρημένο.",
                                generic:true
                            })
                            return;
                        }
                    
                    
                        const updatedMedicines =  nonSentPrescription ? [...nonSentPrescription.medicines, newMedicine] : [newMedicine]

                        const newPrescription = {
                            id: Date.now(),
                            sent: false,
                            medicines: updatedMedicines,
                            response: {
                                sent: false
                            }
                        };


                        if(prescriptions.length===0){
                            setDemoDialog({ 
                                status:true,
                                description:<>
                                <Typography variant="subtitle2" gutterBottom fontWeight="bold">
                                  Το φάρμακο προστέθηκε με επιτυχία!
                                </Typography>
                                <br></br>
                                <Typography variant="subtitle2" gutterBottom >
                                  Η εφαρμογή δημιούργησε αυτόματα μια νέα ή ενημέρωσε μια υπάρχουσα συνταγή, βάσει των χαρακτηριστικών του φαρμάκου.
                                </Typography>
                                
                                <Typography variant="subtitle2" gutterBottom >
                                  Επίσης, όλα τα απαραίτητα θεραπευτικά πρωτόκολλα καταχωρήθηκαν αυτόματα, χωρίς να χρειαστεί να κάνετε κάτι εσείς.
                                </Typography>
                                
                                <Typography variant="subtitle2" paragraph >
                                  Μπορείτε να συνεχίσετε να προσθέτετε όσα φάρμακα θέλετε, και αυτά θα καταχωρούνται στις αντίστοιχες συνταγές.
                                </Typography>
                                
                                <Typography variant="subtitle2" gutterBottom fontWeight="bold">
                                  Επόμενα βήματα:
                                </Typography>
                                
                                <Typography variant="subtitle2">
                                  Όταν ολοκληρώσετε την προσθήκη φαρμάκων, μπορείτε να στείλετε τη συνταγή.
                                </Typography>
                              </>
                            })
                        }
                     
          
                    
                        addPrescription ([...sentPrescriptions, newPrescription]);
                        resetMedicineData();
                    };

                    return(
                        <>  
                            
                            {selectedMedication && 
                            <Tooltip
                            title= {!helpActivatedTooltips ?
                            <React.Fragment>
                                <Typography variant='subtitle2' color="inherit">Επιλέγοντας "ΠΡΟΣΘΗΚΗ" το φάρμακο που επιλέξατε θα καταχωρηθεί σε μία υπάρχουσα η νέα συνταγή . Η συνταγή στην οποία θα καταχωρηθεί εξαρτάται από τα χαρακτηριστικά του φαρμάκου καθώς και τις επιλογές που κάνατε κατά την καταχώρηση του φαρμάκου. Αφού ολοκληρώσετε την καταχώρηση όλων των φαρμάκων του ασθενή, τότε μπορείτε να καταχωρήσετε τις συνταγες που δημιουργήθηκαν.</Typography>
                            </React.Fragment>
                            :''} 
                            >
                            
                            <Button className="addMedicine" style={{ marginTop: '1rem', float: 'right'}} variant='contained' color='primary' onClick={()=>createNewPrescription()}>
                                ΠΡΟΣΘΗΚΗ
                            </Button>
                            </Tooltip>}         

                        
                        </>
                    )
                }
                const PrescriptionSupport = ()=>{

               
                    //The selected medicines by the user
                    const [medicinesSelected, setMedicinesSelected] = useState(dummyChronicMedicines)
                    //Transient comment value
                    const [openDialog, setOpenDialog] = useState(false)
          
                    const addPrescription  = useStore(state => state.addPrescription );
                    const prescriptions = useStore(state => state.prescriptions);
        

                    //Close dialog
                    const handleClodeDialog = ()=>{
                        setOpenDialog(false)
                    }

                    //Updates the selected medicines
                    function handleUpdateSelectedMeds (x){
                        const updatedSelection = medicinesSelected.map(xx=>{
                            if(x.barcode === xx.barcode){
                    
                                return{
                                    ...x,
                                    selected:!x.selected
                                }
                            }
                            else{
                                return xx
                            }
                        })
                        setMedicinesSelected(updatedSelection)
                    }

      
                    //Register the medicines
                    function handleRegisterMeds ()  {
                        // Get selected medicines
                        const selectedMeds = medicinesSelected.filter(med => med.selected);
                        if(!selectedMeds.length){
                            setMedicinesSelected(dummyChronicMedicines)
                            return
                        }
                        
                        // Transform them to prescription format
                        const newMedicines = selectedMeds
                        
                        // Create new prescription
                        const newPrescription = {
                            id: Date.now(),
                            sent: false,
                            medicines: newMedicines,
                            response: {
                                sent: false
                            }
                        };
                        
                        // Add to prescriptions
                        const sentPrescriptions = prescriptions.filter(x => x.sent);
                        addPrescription([...sentPrescriptions, newPrescription]);
                        
                        // Close dialog and reset
                        setOpenDialog(false);
                        setMedicinesSelected(dummyChronicMedicines)

                        if(prescriptions.length===0){
                            setDemoDialog({ 
                                status:true,
                                description:<>
                                <Typography variant="subtitle2" gutterBottom fontWeight="bold">
                                  Τα φάρμακα προστέθηκαν με επιτυχία!
                                </Typography>
                                <br></br>
                                <Typography variant="subtitle2" gutterBottom >
                                  Η εφαρμογή δημιούργησε αυτόματα μια νέα ή ενημέρωσε μια υπάρχουσα συνταγή, βάσει των χαρακτηριστικών των φαρμάκων.
                                </Typography>
                                
                                <Typography variant="subtitle2" gutterBottom >
                                  Επίσης, όλα τα απαραίτητα θεραπευτικά πρωτόκολλα καταχωρήθηκαν αυτόματα, χωρίς να χρειαστεί να κάνετε κάτι εσείς.
                                </Typography>
                                
                                <Typography variant="subtitle2" paragraph >
                                  Μπορείτε να συνεχίσετε να προσθέτετε όσα φάρμακα θέλετε, και αυτά θα καταχωρούνται στις αντίστοιχες συνταγές.
                                </Typography>
                                
                                <Typography variant="subtitle2" gutterBottom fontWeight="bold">
                                  Επόμενα βήματα:
                                </Typography>
                                
                                <Typography variant="subtitle2">
                                  Όταν ολοκληρώσετε την προσθήκη φαρμάκων, μπορείτε να στείλετε τη συνταγή.
                                </Typography>
                              </>
                            })
                        }
                    };
                       
               

             
            

                            


                    

                    const handleClick = ()=>{
                        setOpenDialog(prev=>!prev)
                    }
                


                    return(
                       

                            !selectedMedication &&

                            <>
                            <Tooltip
                                title= {!helpActivatedTooltips ?
                                <React.Fragment>
                                    <Typography variant='subtitle2' color="inherit">Με ένα κλικ στο κουμπί "Υποβοήθηση", μπορείτε να συνταγογραφήσετε γρήγορα τα φάρμακα που λαμβάνει συχνά ο ασθενής.</Typography>
                                </React.Fragment>
                                :''} 
                                >
                                <Button variant="outlined" color="primary" style={{ marginTop: '1rem', float: 'right'}}   onClick={handleClick} >
                                    ΥΠΟΒΟΗΘΗΣΗ
                                </Button>
                            </Tooltip>

                            <Dialog fullWidth maxWidth="md" onClose={handleClodeDialog} open={openDialog}>

                                
                                <DialogTitle >                         
                                    Υποβοήθηση συνταγογράφησης
                                </DialogTitle>
                             

                                { prescriptions.length ?

                                <DialogContent dividers> 

                                    <Typography variant ="subtitle2" color="textSecondary">
                                        Για να χρησιμοποιήσετε την υποβοήθηση συνταγογράφησης δεν θα πρέπει να έχετε εισάγει κανένα φάρμακο και κανένα θεραπευτικό πρωτόκολλο στην επίσκεψη.
                                    </Typography>

                                </DialogContent>
                                :
                                <DialogContent dividers> 

                                    <Typography variant ="subtitle2" color="textSecondary">
                                        Η υποβοήθηση συνταγογράφησης σας διευκολύνει να καταχωρήσετε τα φάρμακα των ασθενών σας.
                                        Το σύστημα συμπληρώνει αυτόματα τις πληροφορίες που χρειάζονται, σύμφωνα με το τελευταίο δοσολογικό σχήμα, διάγνωση και θεραπευτικό πρωτόκολλο που χρησιμοποιήθηκαν στον ασθενή.
                                        Για να καταχωρήσετε φάρμακα στον ασθενή, επιλέξτε τα και στη συνέχεια κάντε κλικ στο κουμπί "ΚΑΤΑΧΩΡΗΣΗ".
                                    </Typography>

                                    <br></br>
                                    <br></br>

                                    <List>
                                    {medicinesSelected.map(x=>
                                        <ListItem key={x.barcode}>
                                            <FormControlLabel 
                                            label= {
                                                <React.Fragment>
                                                    <Grid 
                                                    container
                                                    direction="column"
                                                    spacing={1}>
                                                        <Typography variant="subtitle2" color="textPrimary"> {x.Medication} </Typography> 
                                                        <Typography variant="subtitle2" color="textPrimary"> Διάγνωση: {x.diagnosisWithCode[0]?.name} </Typography> 
                                                        <Typography variant="caption" color="textSecondary"> Εμβαλάγια: {x.Quantity.name}  Επαναληψιμότητα: {x.Repeat.name}.</Typography> 
                                                        <Typography variant="caption" color="textSecondary"> Δοσολογικό σχήμα: {x.Dose.name}  {x.Frequency?.name} για {x.Days.name}.</Typography> 
                                                    </Grid>
                                                </React.Fragment>
                                            } 
                                            control={<Checkbox color="primary" checked={x.selected} onChange={()=>handleUpdateSelectedMeds(x)} />
                                            }/> 
                                     
                                        </ListItem>
                                    )}
                                    </List>
                                   
         
                                    
                                </DialogContent>}

                                <DialogActions>

                                    { prescriptions.length ?
                                    <Button variant="outlined" color='primary' onClick={handleClodeDialog} >
                                        OK      
                                    </Button>
                                    :
                                    <Button variant="outlined" color='primary' onClick={()=>handleRegisterMeds()} >
                                        ΚΑΤΑΧΩΡΗΣΗ   
                                    </Button>}
                                
                                    
                                </DialogActions>

                            </Dialog>
                            </>

                      
                    )

                }



                


        




                
    


                return(

                    <>
                

                
                        
            
                        <Collapse in={true}>
                        
                            <Grid
                            container
                            direction="row"
                            justifyContent="flex-start" 
                            spacing={1}         
                            >
                                
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Medication/>      
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Collapse in={ selectedMedication ? true : false }>
                                        <Diagnosis/> 
                                    </Collapse>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Collapse in={ selectedMedication && selectedDiagnosis.id ? true : false }>
                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="flex-start"
                                            alignItems="flex-start"
                                            spacing={1}
                                            >
                                            <Grid className="dosageSchema" item>
                                                <Quantity/>  
                                            </Grid>
                                            <Grid className="dosageSchema" item>
                                                <Dose/>  
                                            </Grid>
                                            <Grid className="dosageSchema" item>
                                                <Frequency/>  
                                            </Grid>
                                            <Grid className="dosageSchema" item>
                                                <Days/>  
                                            </Grid>
                                            <Grid className="repeteability" item>
                                                <Repeat/>  
                                            </Grid>
                        

                                            <Grid item>
                                                <CopaymentAndDiseaseAndZeroCase/>  
                                            </Grid>             
                                            <Grid  item>
                                                <PrescriptionComment/>  
                                            </Grid>
                                            <Grid item>
                                                <MedicationComment/>  
                                            </Grid>           
                                        </Grid> 
                                    </Collapse> 
                                </Grid>
                                <Grid item xs={12}>
                                
                                    <MediacationInfoDialog/>                                                          
                                    
                                    <Protocols/>   

                                    <VisitProtocols/> 
                                                                        
                                    <RecomendationMain />
                            
                                    <RegisterMedicine />

                                    <PrescriptionSupport/>
            
                                </Grid>  

                        

                            </Grid>  
                    
                        </Collapse>


                    </>
                )
            }
            
            return (          
                
                <Card id="selectDosageSchema" className={classes.root}>
                    <CardHeader
                    className={classes.header}
                    title={<PatientInfo/>}
                    />
                
                    <CardContent>            
                    <PrescrptionForm/>
                    </CardContent>
                </Card>
        
            )

        }         
        const PrescriptionPresentation = () => {
            const breakpointColumnsObj = {
            default: 3,
            1100: 2,
            700: 1,
            500: 1
            };
        
            const prescriptions = useStore(state => state.prescriptions);
    

        
        
            const SinglePrescription = (props) => {
                const x = props.props;
               
               
                const prescriptions = useStore(state => state.prescriptions);
                const addPrescription  = useStore(state => state.addPrescription );

                const otherPresc =prescriptions.length ?  prescriptions.filter(y=>y.id!==x.id) : []

       

            
                const indexPrescription = props.number;

                
                const send = () => {

                
                  
                    addPrescription ([...otherPresc, {...x,  sent: true,}]);
    
                };

                const deletePresc =()=>{

             
                    addPrescription (otherPresc);

                    
                }
            
            
            
                const Medication = (z) => {

                    const [expanded, setExpanded] = useState(false);
                    const handleExpandClick = () => {
                        setExpanded(!expanded);
                    };





                    

            
                    
                    const deleteMed = () => {

                        const samePresc = prescriptions.find(y=>y.id===x.id)
                
                        const nonDeleted =  samePresc.medicines.filter(x=>x.MedicationInfo.barcode !== z.props.MedicationInfo.barcode )
                        
                        

                        const newPrescription = nonDeleted.length ? {
                        ...samePresc,
                        medicines: nonDeleted
                        }:[]

                        console.log (newPrescription)

                        
                    
                        addPrescription (otherPresc.concat(newPrescription));
        
                    };







            

                    return (
                    <div key={z.props.MedicationInfo.barcode}>
                        <Grid container direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                        <Grid item xs={9}>
                            <ListItem button onClick={handleExpandClick}>
                            <ListItemText 
                                style={{wordBreak: 'break-all', fontWeight: "bold"}} 
                                secondary={
                                <Typography variant='body2' style={{fontWeight: "bold"}}>
                                    {`${z.props.MedicationInfo.commercialName} ${z.props.MedicationInfo.content}`}
                                </Typography>
                                } 
                                primary={'Φάρμακο: '}
                                primaryTypographyProps={{variant: "caption", color: "textSecondary"}}
                            />
                            </ListItem>
                        </Grid>
                        {!x.sent && (
                            <Grid item xs={2}>
                            <Tooltip title="Αφαίρεση φαρμάκου από την συνταγή">
                                <IconButton onClick={() => deleteMed()}>
                                <Cancel />
                                </IconButton>
                            </Tooltip>
                            </Grid>
                        )}
                        </Grid>
            
                        <Collapse in={expanded} timeout="auto" unmountOnExit>
                        <Grid container direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                            <Grid item xs={12}>
                            <ListItem>
                                <ListItemText 
                                primary={'Διάγνωση: '} 
                                secondaryTypographyProps={{variant: "subtitle2", color: "textPrimary"}} 
                                secondary={z.props.Diagnosis.title}
                                primaryTypographyProps={{variant: "caption", color: "textSecondary"}}
                                />
                            </ListItem>
                            </Grid>
                            <Grid item xs={3}>
                            <ListItem>
                                <ListItemText 
                                primary={'Εμβαλάγια: '} 
                                secondaryTypographyProps={{variant: "subtitle2", color: "textPrimary"}} 
                                secondary={z.props.Quantity.id}
                                primaryTypographyProps={{variant: "caption", color: "textSecondary"}}
                                />
                            </ListItem>
                            </Grid>
                            <Grid item xs={3}>
                            <ListItem>
                                <ListItemText 
                                primary={'Δόση: '} 
                                secondaryTypographyProps={{variant: "subtitle2", color: "textPrimary"}} 
                                secondary={z.props.Dose.id}
                                primaryTypographyProps={{variant: "caption", color: "textSecondary"}}
                                />
                            </ListItem>
                            </Grid>
                            <Grid item xs={6}>
                            <ListItem>
                                <ListItemText 
                                primary={'Φαρμακοτεχνική μορφή: '} 
                                secondaryTypographyProps={{variant: "subtitle2", color: "textPrimary"}} 
                                secondary={z.props.exitIfet.status ? z.props.exitIfet.ifetForm : z.props.MedicationInfo.doseUnit}
                                primaryTypographyProps={{variant: "caption", color: "textSecondary"}}
                                />
                            </ListItem>
                            </Grid>
                            <Grid item xs={12}>
                            <ListItem>
                                <ListItemText 
                                primary={'Δοσολογικό σχήμα: '} 
                                secondaryTypographyProps={{variant: "subtitle2", color: "textPrimary"}} 
                                secondary={`${z.props.Frequency.name} για ${z.props.Days.id} ημέρες.`}
                                primaryTypographyProps={{variant: "caption", color: "textSecondary"}}
                                />
                            </ListItem>
                            </Grid>
                            <Grid item xs={6}>
                            <ListItem>
                                <ListItemText 
                                primary={'Επανάληψη: '} 
                                secondaryTypographyProps={{variant: "subtitle2", color: "textPrimary"}} 
                                secondary={z.props.Repeat.name}
                                primaryTypographyProps={{variant: "caption", color: "textSecondary"}}
                                />
                            </ListItem>
                            </Grid>
                            <Grid item xs={6}>
                            <ListItem>
                                <ListItemText 
                                primary={'Συμμετοχή: '} 
                                secondaryTypographyProps={{variant: "subtitle2", color: "textPrimary"}} 
                                secondary={z.props.Copayment.name}
                                primaryTypographyProps={{variant: "caption", color: "textSecondary"}}
                                />
                            </ListItem>
                            </Grid>
                        </Grid>
                        </Collapse>
                        <Divider light={true} />
                    </div>
                    );
                };
            
                return (
                    <Tooltip
                    title= {!helpActivatedTooltips ?
                    <React.Fragment>
                        <Typography  variant='h6' color="inherit">{!x.sent ? "Συνταγή ΠΡΟΣ ΑΠΟΣΤΟΛΗ" :" ΑΠΕΣΤΑΛΜΕΝΗ συνταγή" }</Typography>
                        <Typography variant='subtitle2' color="inherit">
                        {!x.sent ?'Η συνταγή που δημιουργήσατε είναι προσωρινή, δεν έχει ακόμα καταχωρηθεί. Μπορείτε να την καταχωρήσετε επιλέγοντας το εικονίδιο "Αποστολή συνταγής" που βρίσκεται πάνω δεξιά στην επικεφαλίδα. Για να προβάλλετε τις πληροφορίες του φαρμάκου όπως διάγνωση και δοσολογικό σχήμα, κάντε κλικ πάνω στο φάρμακο. Σε περίπτωση που θέλετε να αφαιρέσετε ένα φάρμακο από τη συνταγή, επιλέξτε το αντίστοιχο εικονίδιο "Χ".'
                        :
                        "Η συνταγή είναι καταχωρημένη στο Σύστημα της ηλεκτρονικής συνταγογράφησης . Σε περίπτωση που θέλετε να ακυρώσετε τη συνταγή επιλέξτε το εικονίδιο του 'Κάδου' , που βρίσκεται στο δεξί τμήμα της επικεφαλίδας της συνταγής. Για να την εκτυπώσετε επιλέξτε το εικονίδιο του 'Εκτυπωτή'. Τέλος για να στείλετε την άυλη συνταγή στον ασθενή επιλέξτε το εικονίδιο του 'mail'."} 
                        </Typography>
                    </React.Fragment>
                    :''} 
                    >
                    <Card className="prescriptionPresentationBeforeSend" style={{ marginTop: '1rem' }}>
                    <CardHeader
                        className={x.sent && "prescriptionPresentationAfterSend"}
                        style={!x.sent ? 
                        {color: "#fafafa", backgroundColor: "#9fa8da"} : 
                        {color: "#212121", backgroundColor: "#fafafa"}
                        }
                        title={
                        <Typography style={{fontWeight: "bolder"}} display='block' noWrap variant="body1">
                            {`Συνταγή ${indexPrescription + 1}`} 
                        </Typography>
                        }
                        action={
                        x.sent ? (
                            <>
                            <Tooltip title="Ακύρωση συνταγής">
                                <IconButton onClick={deletePresc}><Delete /></IconButton>
                            </Tooltip>
                            <Tooltip title="Εκτύπωση συνταγής">
                                <IconButton onClick={()=>   setDemoMessage({
                            status:true,
                            severity:"info",
                            description: "το κουμπί εκτυπώνει την συνταγή"
                        })}  ><Print /></IconButton>
                            </Tooltip>
                            <Tooltip title="Άυλη αποστολή συνταγής">
                                <IconButton onClick={()=>   setDemoMessage({
                            status:true,
                            severity:"info",
                            description: "το κουμπί ξαναστέλνει την άυλη συνταγή."
                        })} ><Email /></IconButton>
                            </Tooltip>
                            </>
                        ) : (
                            <>
                            <Tooltip title="Αποστολή συνταγής">
                                <IconButton  onClick={send} ><Send /></IconButton>
                            </Tooltip>
                            </>
                        )
                        }
                    />
            
                    <CardContent>
                        <List>
                        {x.medicines.map((z, index) => (
                            <Medication key={index} props={z} index={index} />
                        ))}
                        </List>
                    </CardContent>
                    </Card>
                    </Tooltip>
                );
            };
        
            return (
            <div>
                <Masonry
                breakpointCols={breakpointColumnsObj}
                className="my-masonry-grid"
                columnClassName="my-masonry-grid_column"
                >
                {prescriptions.map((x, indexPrescription) => (
                    <div key={indexPrescription}>
                    <SinglePrescription number={indexPrescription} props={x} />
                    </div>
                ))}
                </Masonry>
        
                {prescriptions.length === 0 && (
                <div className="flex justify-center items-center" style={{height: '39vh'}}>
                    <FaFilePrescription style={{width: '100%', height: '100%', color: '#9fa8da'}} />
                </div>
                )}
            </div>
            );
        };




        return (
        
            logged===true ?    
            <div  className={classes.root}> 

                <HelperPoper/>

                <Grid 
                container 
                spacing={3} 
                direction="row" 
                > 
                    
                    <Grid item xs={12}>
                    <CreatePrescription/>
                    </Grid>

                    <Grid  item xs={12}>
                    <PrescriptionPresentation/>
                    </Grid>

                    <Grid item xs={12}>
                    <NavigationButtons/>
                    </Grid>

                </Grid>
                
                <DemoMessage/>

            </div>
            : 
            <Navigate to="/"/> 
            
        )
    }

    return(
        <>
            <PrescriptionPageAuxiliary/>
            <DemoDialog/>
            <PrescriptionDashboard/>
        </>
    )
}

//Component to help the user learn the app
export const HelperPoper = () => {

    const [steps, setSteps] = useContext(HelperStepsContext)
    const [hideContent, setHideContent] = useState(false)
    const [changePos, setChangePos] = useState(false)
    const [pageSteps, setPageSteps] = useState([]) 
    const [currentStep, setCurrentStep] = useState({           
        header: '',
        target: '',
        content: '',
        index :0,
        page:"",
        initialStep:false,
        finalStep:false
    })

    
    const previousDOMReference = useRef(null)

    //Load the help and highlight the fists element
    useEffect(()=>{

  
        if(steps.status){
            setTimeout(() =>{ 
                const pageSteps = steps.data.flatMap(x=>{
                    if(x.page==window.location.pathname || x.page==="all"){
                        return x
                    }
                    else{
                        return []
                    }
                }).sort((a, b) => a.index - b.index)
                setPageSteps(pageSteps)
                setCurrentStep(pageSteps[0])
        
                const currentElement = [...document.getElementsByClassName(pageSteps[0].target)]
        
                // Change the CSS properties of the element
                if(currentElement.length){
                    currentElement.forEach(x=>{x.style.border = '5px dashed #f4c430'; x.style.borderRadius = '5px'})
                } 
            }, 1000)
        }
        else{
            setCurrentStep({           
                header: '',
                target: '',
                content: '',
                index :0,
                page:"",
                initialStep:false,
                finalStep:false
            })
        }
       

    },[steps])
    //Manipulate the DOM highlighting the element to guide the user
    useEffect(()=>{

        //If the help is activated, then guide the user 
        if(steps.status){

            if(previousDOMReference.current){
            
                const previousElement = [...document.getElementsByClassName(previousDOMReference.current.target)]
                if(previousElement.length){
                    previousElement.forEach(x=>{x.style.border = ''; x.style.borderRadius = ''})
                }
            }

            const currentElement = [...document.getElementsByClassName(currentStep.target)]
            // Change the CSS properties of the element
            if(currentElement.length){
                currentElement.forEach(x=>{x.style.border = '5px dashed  #f4c430 '; x.style.borderRadius = '5px'})
            } 
            //Every 1.5 seconds checks to find the "currentElement"
            const intervalId = setInterval(() => {
                const currentElement = [...document.getElementsByClassName(currentStep.target)]
                if(currentElement.length){
                    currentElement.forEach(x=>{x.style.border = '5px dashed  #f4c430 '; x.style.borderRadius = '5px'})
                } 
    
            }, 1500);
        
         

            previousDOMReference.current = currentStep

            // Clean up the interval when the component unmounts
            return () => clearInterval(intervalId);
        }
        //if it is not Close the highlight
        else{
            const currentElement = [...document.getElementsByClassName(currentStep.target)]
            if(currentElement.length){
                currentElement.forEach(x=>{x.style.border = ''; x.style.borderRadius = '5px'})
            } 
        }

    },[currentStep, steps])


    //Move to the next info
    const handleNext = ()=>{
        const next = pageSteps.find(x=>x.index===currentStep.index+1)
        next && setCurrentStep(next)
    }
    //Move to the previous info
    const handlePrevious = ()=>{
        const next = pageSteps.find(x=>x.index===currentStep.index-1)
        next && setCurrentStep(next)
    }
    //hide the content of the snackbar
    const hide = () => {
       setHideContent(prev=>!prev)
    }
    //Change position of the snackbar
    const changePosition = () => {
        setChangePos(prev=>!prev)
    }
    //Close the help
    const handleCloseHelp = ()=>{
        setSteps({
            status:false,
            data:[]
          })
    }

    
 
      

    return(
  
        <Snackbar
        style={{maxWidth:"25rem", opacity:0.9}}
        anchorOrigin={{
          vertical: !changePos ?'bottom' : 'top',
          horizontal: !changePos ?'left' : 'right',
        }}
        open={steps.status && currentStep.index!==0}
        message={
        <React.Fragment>
            <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center">
                <Grid item xs={9}>
                    <Typography variant='subtitle2' color="inherit">
                        {currentStep.header}
                    </Typography>
                </Grid>
                <Grid item xs={1}>
                    <Tooltip title="Αποκρυψη/εμφάνιση πληροφοριών">
                        <IconButton color="inherit" onClick={hide} aria-label="Απόκρυψη">
                            {hideContent ? <Maximize /> : <Minimize/>}
                        </IconButton>
                    </Tooltip>
                </Grid>
                <Grid item xs={1}>
                    <Tooltip title="Αλλαγή θέσης πληροφοριών">
                        <IconButton color="inherit" onClick={changePosition} aria-label="Απόκρυψη">
                        <PanTool/>
                        </IconButton>
                    </Tooltip>
                </Grid>
                <Grid item xs={1}>
                    <Tooltip title="Κλείσιμο βοήθειας">
                        <IconButton color="inherit" onClick={handleCloseHelp} aria-label="Κλείσιμο βοήθειας">
                        <Close/>
                        </IconButton>
                    </Tooltip>
                </Grid>
              

            </Grid>

           
            <Collapse in={!hideContent}>
                <Typography style={{ whiteSpace: "pre-line" }} button onClick={changePosition} variant='caption' color="inherit">
                {currentStep.content}
                </Typography>
            </Collapse>
        </React.Fragment>
        }
        action={
            <Collapse in={!hideContent}>
                <React.Fragment>

                    <Button disabled={currentStep.initialStep} onClick={handlePrevious} style={{margin:"1rem"}} size="small" variant="outlined" color="inherit">
                        ΠΡΟΗΓΟΥΜΕΝΟ
                    </Button>
        
                    <Button disabled={currentStep.finalStep} onClick={handleNext} size="small" variant="outlined" color="inherit">
                        ΕΠΟΜΕΝΟ
                    </Button>

                </React.Fragment>
            </Collapse>
        }
      />

 
    )
}
